var ze = Object.defineProperty;
var Ze = (o, e, t) => e in o ? ze(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var r = (o, e, t) => Ze(o, typeof e != "symbol" ? e + "" : e, t);
var Oe = /* @__PURE__ */ ((o) => (o.CLIENT = "CLIENT", o.CDC = "CDC", o))(Oe || {}), Ee = /* @__PURE__ */ ((o) => (o.MANUAL = "MANUAL", o.AUTOMATIC = "AUTOMATIC", o.COUPON = "COUPON", o.CPU = "CPU", o))(Ee || {}), J = /* @__PURE__ */ ((o) => (o.WEB = "web", o.BANK = "banque", o))(J || {}), F = /* @__PURE__ */ ((o) => (o.CUSTOM = "custom", o.AP1 = "ap1", o.AP2 = "ap2", o.AP3 = "ap3", o.AP4 = "ap4", o.PROD = "prod", o))(F || {}), d = /* @__PURE__ */ ((o) => (o.CASH = "COMPTANT", o.COFIDIS = "COFIDIS", o.COFIDIS_X3 = "COFIDIS_X3", o.COFIDIS_X12 = "COFIDIS_X12", o.COFIDIS_X24 = "COFIDIS_X24", o.MULTI_PRODUCT = "MULTI_PRODUIT", o.EDP = "EDP", o.YOUNITED = "YOUNITED", o.YOUNITED_X3 = "YOUNITED_X3", o.YOUNITED_X12 = "YOUNITED_X12", o.YOUNITED_X24 = "YOUNITED_X24", o.YOUNITED_X36 = "YOUNITED_X36", o))(d || {});
const Ie = {
  COMPTANT: {
    label: "Comptant"
  },
  COFIDIS: {
    label: "Financement Cofidis Pay"
  },
  COFIDIS_X3: {
    label: "Paiement en 3x sans frais"
  },
  COFIDIS_X12: {
    label: "Paiement en 12x avec Cofidis Pay"
  },
  COFIDIS_X24: {
    label: "Paiement en 24x avec Cofidis Pay"
  },
  YOUNITED: {
    label: "Financement à crédit",
    fullLabel: "Financement en plusieurs fois avec Younited"
  },
  YOUNITED_X3: {
    label: "Paiement 3 fois avec Younited"
  },
  YOUNITED_X12: {
    label: "Paiement 12 fois avec Younited"
  },
  YOUNITED_X24: {
    label: "Paiement 24 fois avec Younited"
  },
  YOUNITED_X36: {
    label: "Paiement 36 fois avec Younited"
  }
};
var w = /* @__PURE__ */ ((o) => (o.ACQUISITION = "ACQUISITION", o.ACQUISITIONFIX = "ACQUISITIONFIX", o.RENEW = "RENOUVELLEMENT", o))(w || {}), te = /* @__PURE__ */ ((o) => (o.COLLABORATOR = "collaborator", o.CLIENT = "client", o))(te || {}), A = /* @__PURE__ */ ((o) => (o.MONTH12 = "month12", o.MONTH18 = "month18", o.MONTH24 = "month24", o))(A || {}), ie = /* @__PURE__ */ ((o) => (o.GP = "GP", o.PRO = "PRO", o.ENTREPRISE = "ENTREPRISE", o))(ie || {});
class Xe {
  constructor() {
    r(this, "store", {});
  }
  get length() {
    return Object.keys(this.store).length;
  }
  clear() {
    this.store = {};
  }
  getItem(e) {
    return this.store[e] ?? null;
  }
  key(e) {
    return Object.keys(this.store)[e] ?? null;
  }
  removeItem(e) {
    delete this.store[e];
  }
  setItem(e, t) {
    this.store[e] = t.toString();
  }
}
class et {
  constructor(e) {
    r(this, "localKeysConf", { configurations: [] });
    r(this, "sessionKeysConf", {});
    r(this, "prefix", "bytel");
    r(this, "config");
    this.config = e;
  }
  clear() {
    this.clearTag();
  }
  clearTag(e) {
    this._cleanStorage(this.sessionKeysConf, e), this._cleanStorage(this.localKeysConf, e);
  }
  get(e, t = !0) {
    let i = null;
    const s = this._getData(e, t);
    if (s !== null)
      try {
        i = Object.prototype.hasOwnProperty.call(s, "data") ? s.data : s;
        const n = (/* @__PURE__ */ new Date()).getTime();
        s.expiresTimestamp && s.expiresTimestamp < n && (i = null, this.remove(e, t));
      } catch (n) {
        console.error(n);
      }
    return i;
  }
  getExpires(e, t = !0) {
    const i = this._getData(e, t);
    if (i !== null)
      return i == null ? void 0 : i.expiresTimestamp;
  }
  remove(e, t = !0) {
    const i = t ? `${this.prefix}_${e}` : e;
    this._getStorageInstance(e).removeItem(i);
  }
  /**
   *
   * @param key Key value
   * @param value
   * @param prefix if true add checkout_ before key
   * @param expires expirationTimestamp - Set by default from configuration
   */
  set(e, t, i = !0, s = this._getDefaultExpirationValue()) {
    const n = i ? `${this.prefix}_${e}` : e, c = JSON.stringify({
      data: t,
      expiresTimestamp: s
    });
    this._getStorageInstance(e).setItem(n, c);
  }
  addLocalKey(e) {
    return this.localKeysConf = {
      ...this.localKeysConf,
      ...e
    }, this.localKeysConf;
  }
  addSessionKey(e) {
    return this.sessionKeysConf = {
      ...this.sessionKeysConf,
      ...e
    }, this.sessionKeysConf;
  }
  _getStorageInstance(e) {
    return Object.keys(this.sessionKeysConf).includes(e) ? typeof sessionStorage > "u" ? new Xe() : sessionStorage : typeof localStorage > "u" ? new Xe() : localStorage;
  }
  _cleanStorage(e, t) {
    Object.keys(e).forEach((i) => {
      (!t || e[i].includes(t)) && (this.remove(i), this.remove(i, !1));
    });
  }
  _getData(e, t = !0) {
    const i = t ? `${this.prefix}_${e}` : e, s = this._getStorageInstance(e).getItem(i);
    if (s !== null)
      try {
        return JSON.parse(s);
      } catch (n) {
        console.error(n);
      }
    return null;
  }
  _getDefaultExpirationValue() {
    const e = this.config.cartExpiration;
    if (e > 0) {
      const t = /* @__PURE__ */ new Date();
      return t.setHours(t.getHours() + e), t.getTime();
    }
    return null;
  }
}
var He = /* @__PURE__ */ ((o) => (o.ORDER = "ORDER", o.CUSTOMER = "CUSTOMER", o))(He || {});
class xe extends et {
  constructor(t) {
    super(t);
    r(this, "prefix", "checkout");
    this.localKeysConf = {
      cart: [
        "ORDER"
        /* ORDER */
      ],
      galliumPrices: [
        "ORDER",
        "CUSTOMER"
        /* CUSTOMER */
      ],
      click_collect: [
        "ORDER"
        /* ORDER */
      ],
      eligibility: [
        "ORDER"
        /* ORDER */
      ],
      fai_elige_tokyo: [
        "ORDER"
        /* ORDER */
      ],
      eligibilityUserAddress: [
        "ORDER"
        /* ORDER */
      ],
      plan_cart_scheme: [
        "ORDER"
        /* ORDER */
      ],
      phone_scheme: [
        "ORDER"
        /* ORDER */
      ],
      fai: [
        "ORDER"
        /* ORDER */
      ],
      provider_results: [
        "ORDER"
        /* ORDER */
      ],
      current_step: [
        "ORDER"
        /* ORDER */
      ]
    }, this.sessionKeysConf = {
      mrz: [
        "ORDER",
        "CUSTOMER"
        /* CUSTOMER */
      ],
      promoConfigurator: [
        "ORDER"
        /* ORDER */
      ],
      steps: [
        "ORDER"
        /* ORDER */
      ],
      mobile_recovery_current_product: [
        "ORDER"
        /* ORDER */
      ],
      mobileRecoveryCurrentStep: [
        "ORDER"
        /* ORDER */
      ],
      scoring: [
        "CUSTOMER"
        /* CUSTOMER */
      ],
      deviceFingerPrint: [
        "CUSTOMER"
        /* CUSTOMER */
      ],
      deviceFingerPrintKeys: [
        "CUSTOMER"
        /* CUSTOMER */
      ],
      UUID: [
        "CUSTOMER"
        /* CUSTOMER */
      ],
      ftth3Clics: [
        "ORDER"
        /* ORDER */
      ],
      idsPorta: [
        "ORDER"
        /* ORDER */
      ],
      customer: [
        "CUSTOMER"
        /* CUSTOMER */
      ],
      funding_key: [
        "ORDER"
        /* ORDER */
      ]
    };
  }
  saveConfigurations(t) {
    const s = (/* @__PURE__ */ new Date()).getTime() + 36e5;
    this.set("configurations", t, !0, s);
  }
}
function tt(o) {
  const e = {
    xSource: "portailvente_web",
    salesApiVersion: "4",
    cartExpiration: 48,
    yama: {
      referrers: []
    },
    partner: {}
  };
  if (typeof o != "string")
    return {
      ...e,
      ...o
    };
  switch (o) {
    case F.AP1:
      return {
        ...e,
        environment: o,
        resourceUrl: "https://api.sandbox.bouyguestelecom.fr/ap1",
        xBanc: "ap1000/master"
      };
    case F.AP2:
      return {
        ...e,
        environment: o,
        resourceUrl: "https://api.sandbox.bouyguestelecom.fr/ap2",
        xBanc: "ap2000/master"
      };
    case F.AP3:
      return {
        ...e,
        environment: o,
        resourceUrl: "https://api.sandbox.bouyguestelecom.fr/ap3",
        xBanc: "ap3000/master"
      };
    case F.AP4:
      return {
        ...e,
        environment: o,
        resourceUrl: "https://api.sandbox.bouyguestelecom.fr/ap4",
        xBanc: "ap4000/master"
      };
    case F.CUSTOM:
      return {
        ...e,
        environment: o,
        resourceUrl: "https://api.sandbox.bouyguestelecom.fr/ap2",
        xBanc: "ap2000/master"
      };
    case F.PROD:
    default:
      return {
        ...e,
        environment: o,
        resourceUrl: "https://api.bouyguestelecom.fr"
      };
  }
}
class it {
  constructor() {
    r(this, "length", 1);
  }
  clear() {
  }
  get(e) {
    const t = document.cookie.split(";");
    for (const i of t) {
      const s = i.trim(), [n, c] = s.split("=");
      if (n === e)
        return c;
    }
    return null;
  }
  key() {
    return null;
  }
  removeItem(e) {
    window.document.cookie = `${e}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }
  setItem(e, t, i, s = "/", n = `${window.location.hostname.replace(/^www\./, "")}`, c = !0) {
    window.document.cookie = `${e}=${t}; expires=${i}; path=${s}; domain=${n}; secure=${c}`;
  }
}
var Me = /* @__PURE__ */ ((o) => (o.CLICK_AND_COLLECT = "CLICK_COLLECT", o.RELAIS_EXPRESS = "POINT_RELAIS_EXPRESS", o.RELAIS_COLIS = "POINT_RELAIS", o.LA_POSTE = "LA_POSTE", o.CHRONOPOST = "CHRONOPOST", o.INSTALLER = "INSTALLATEUR", o.DIRECT = "LIVRAISON_DIRECTE", o))(Me || {}), ae = /* @__PURE__ */ ((o) => (o.PORTABILITY = "aUnePortabilite", o.NO_PORTABILITY = "nAPasDePortabilite", o))(ae || {}), a = /* @__PURE__ */ ((o) => (o.accessory = "Accessory", o.accessory_configurable = "Accessory", o.box = "Box", o.edp = "Edp", o.edpFms = "EdpFms", o.faim = "Faim", o.faim_premium = "FaimPremium", o.faim_unlimited = "FaimUnlimited", o.fai_box_generique = "FaiBox", o.fai = "Fai", o.fai_service = "Activation", o.fai_fmd = "Installation", o.insurance = "Insurance", o.option = "Option", o.option_fai = "Option", o.option_salable = "OptionSalable", o.option_partner = "OptionPartner", o.option_remise = "OptionRemise", o.offer_partner = "OptionPartner", o.odr = "Odr", o.plan_ideo = "Ideo", o.plan_ideo_pro = "Ideo", o.plan_omb = "Omb", o.plan_simo = "Simo", o.plan_sowo = "Sowo", o.plan_sowo_renew = "Sowo", o.plan_premium = "Sensation", o.plan_premium_renew = "Sensation", o.phone_simple = "Phone", o.phone = "Phone", o.sim = "Sim", o.qr_esim = "Sim", o.shipping = "Delivery", o._subscription = "Subscription", o._equipement = "Equipment", o._plan = "Plan", o._product = "Product", o["mobile-take-back"] = "MobileTakeBack", o))(a || {}), P = /* @__PURE__ */ ((o) => (o[o.TODAY = 0] = "TODAY", o[o.EVERY_MONTH = 1] = "EVERY_MONTH", o[o.OTHER = 2] = "OTHER", o[o.REPORTED = 3] = "REPORTED", o[o.EVERY_MONTH_INCLUDED = 4] = "EVERY_MONTH_INCLUDED", o))(P || {}), ce = /* @__PURE__ */ ((o) => (o[o.FIX = 0] = "FIX", o[o.POURCENT = 1] = "POURCENT", o))(ce || {}), Ke = /* @__PURE__ */ ((o) => (o.PROSPECT = "PROSPECT", o.CLIENT = "CLIENT", o.GP = "GP", o.PRO = "PRO", o.PORTABILITE = "PORTABILITE", o.INCITATION = "INCITATION", o.CONVERGENCE = "CONVERGENCE", o))(Ke || {});
class Ue {
  getData() {
    return { id: this.id };
  }
}
class x extends Ue {
  constructor(t = {}) {
    super();
    r(this, "id", w.ACQUISITION);
    r(this, "params");
    this.params = t;
  }
  clone() {
    return new x(this.params);
  }
}
class K extends Ue {
  constructor(t) {
    super();
    r(this, "id");
    r(this, "params");
    t = t ?? { id: w.ACQUISITIONFIX }, this.params = t, this.id = (t == null ? void 0 : t.id) ?? w.ACQUISITIONFIX;
  }
  clone() {
    return new K(this.params);
  }
}
class C {
  constructor(e = 0, t = e, i = t, s) {
    this.base = e, this.final = t, this.forever = i, this.duration = s;
  }
  add(e) {
    return this.final = +(this.final + e.final).toFixed(2) || 0, this.forever = +(this.forever + e.forever).toFixed(2) || 0, this.base = +(this.base + e.base).toFixed(2) || 0, e.duration && (this.duration = e.duration), this;
  }
}
class V {
  constructor(e) {
    r(this, "data");
    r(this, "id");
    r(this, "addProduct");
    r(this, "isEligibleEdp", !0);
    r(this, "name");
    r(this, "label");
    r(this, "type");
    r(this, "marketType");
    r(this, "description");
    r(this, "amount");
    r(this, "reductionType");
    r(this, "reductionAmount");
    r(this, "duration");
    r(this, "dates");
    r(this, "message");
    r(this, "relevantProducts");
    r(this, "code");
    r(this, "paymentMethods");
    r(this, "typesMarketing");
    r(this, "fanion");
    r(this, "accessTypes");
    this.data = e, this.id = e.id, this.addProduct = e.addProduct, this.isEligibleEdp = e.isEligibleEdp ?? !0, this.name = e.name, this.label = e.label, this.type = e.type, this.marketType = e.marketType ?? [], this.description = e.description, this.amount = e.amount ?? 0, this.reductionType = e.reductionType, this.reductionAmount = e.reductionAmount, this.duration = e.duration ?? 0, this.dates = e.dates, this.message = e.message, this.relevantProducts = e.relevantProducts ?? [], this.code = e.code, this.paymentMethods = e.paymentMethods ?? [], this.typesMarketing = e.typesMarketing ?? [], this.fanion = e.fanion, this.accessTypes = e.accessTypes ?? [];
  }
  clone() {
    return new V(this.data);
  }
  getAmount(e) {
    return this.reductionType === ce.FIX ? this.amount : this.amount * e / 100;
  }
  equal(e) {
    return e && this.amount === e.amount && this.code === e.code && this.type === e.type && this.relevantProducts.every((t) => e.relevantProducts.includes(t)) && e.relevantProducts.every((t) => this.relevantProducts.includes(t));
  }
}
class N extends V {
  constructor(t) {
    super(t);
    r(this, "pdfLink");
    this.pdfLink = t.pdfLink;
  }
}
class g {
  constructor(e, t, i, s) {
    r(this, "automatic");
    r(this, "manual");
    r(this, "incitation");
    r(this, "coupon");
    this.automatic = e || [], this.manual = t || [], this.incitation = i || [], this.coupon = s;
  }
  static roundPrice(e) {
    return +(Math.floor(+(e * 100).toFixed(1)) / 100).toFixed(2);
  }
  clone() {
    var e;
    return new g(
      this.automatic.map((t) => t.clone()),
      this.manual.map((t) => t.clone()),
      this.incitation.map((t) => t.clone()),
      (e = this.coupon) == null ? void 0 : e.clone()
    );
  }
  canHaveEdp() {
    return !this.automatic.some((e) => !e.isEligibleEdp) && !this.manual.some((e) => !e.isEligibleEdp);
  }
  getDuration(e = !1, t = !1) {
    const i = [
      ...this.automatic,
      ...this.manual,
      ...e ? this.incitation : []
    ].filter((s) => s instanceof N && t || !(s instanceof N)).sort((s, n) => n.duration - s.duration)[0];
    return i ? +i.duration : void 0;
  }
  getPrices(e, t = 0, i = !1, s = !1) {
    let n = e, c = e;
    const u = this.automatic.filter(
      (p) => p instanceof N && s || !(p instanceof N)
    );
    n -= this._getAmountWithPromotions(n, u), c -= this._getAmountWithPromotions(
      n,
      u.filter((p) => p.duration === 0)
    );
    const l = this.manual.filter((p) => !s || !(p instanceof N));
    if (n -= this._getAmountWithPromotions(n, l), c -= this._getAmountWithPromotions(
      n,
      l.filter((p) => p.duration === 0)
    ), i) {
      const p = this.incitation.filter(
        (f) => !s || !(f instanceof N)
      );
      n -= this._getAmountWithPromotions(n, p), c -= this._getAmountWithPromotions(
        n,
        p.filter((f) => f.duration === 0)
      );
    }
    const h = this.coupon ? this.coupon.getAmount(n) : 0;
    return new C(
      e,
      Math.max(t, g.roundPrice(n - h)),
      Math.max(t, g.roundPrice(c)),
      this.getDuration(i, s)
    );
  }
  removeManual(e) {
    this.manual = this.manual.filter((t) => t.id !== e.id);
  }
  addManual(e) {
    return this.manual.some((t) => t.id === e.id) ? !1 : (this.manual.push(e), !0);
  }
  setCoupon(e) {
    this.coupon = e;
  }
  removeCoupon() {
    this.coupon = void 0;
  }
  _getAmountWithPromotions(e, t) {
    return t.reduce((i, s) => i + s.getAmount(e), 0);
  }
}
class Ne {
  constructor() {
    r(this, "totals");
    r(this, "quotes", []);
    r(this, "promotions", new g([], [], []));
    r(this, "currentQuoteIndex", 0);
    r(this, "cartId");
    r(this, "type");
    r(this, "configId");
    r(this, "userId");
    r(this, "lastProductParamsSent");
    r(this, "coupon");
    r(this, "isComingFromProWall", !1);
    r(this, "fundingMethod");
    r(this, "isPro", !1);
  }
  getQuote(e = this.currentQuoteIndex) {
    return this.quotes[e];
  }
  clone() {
    const e = new Ne();
    return e.quotes = this.quotes.map((t) => t.clone()), e.promotions = this.promotions.clone(), e.currentQuoteIndex = this.currentQuoteIndex, e.isPro = this.isPro, e.totals = this.totals, e;
  }
  /**
   * Calculate quotes and cart totals
   *
   * @return void
   */
  calculateTotals() {
    this.totals = this.quotes.reduce(
      (e, t) => {
        const i = t.calculateTotals();
        return e.daily.add(i.daily), e.monthly.add(i.monthly), e.reported.add(i.reported), e;
      },
      { daily: new C(), monthly: new C(), reported: new C() }
    );
  }
  getCustomerCategory() {
    return this.isPro ? ie.PRO : ie.GP;
  }
  isCartEmpty() {
    return this.quotes.reduce((t, i) => t + i.products.length, 0) === 0;
  }
  getAllProducts() {
    return this.quotes.flatMap((e) => e.products);
  }
  getAllGencodes() {
    return this.getAllProducts().map((e) => e.data.gencode);
  }
  hasProProduct() {
    return this.quotes.some((e) => e.hasProProduct());
  }
  isBanking() {
    return this.type === J.BANK;
  }
  isMixed() {
    var i;
    if ((((i = this.quotes) == null ? void 0 : i.length) || 0) < 2)
      return !1;
    const e = this.quotes.some((s) => s.isAcquisition()), t = this.quotes.some((s) => s.isAcquisitionFix());
    return e && t;
  }
  isTelOnly() {
    return this.quotes[0].products.filter((e) => !m.Is(e, a.insurance) && !m.Is(e, a.edp)).every((e) => m.Is(e, a.phone));
  }
  isFaiOnly() {
    const e = this.quotes[0];
    return !this.isMixed() && e.isAcquisitionFix() && m.Is(e.getPrincipalProduct(a.fai), a.fai, !0);
  }
  length() {
    return this.quotes.length;
  }
}
class j extends Ue {
  constructor(t) {
    super();
    r(this, "id");
    r(this, "contractId");
    r(this, "phone");
    r(this, "clientType");
    r(this, "nbTerms");
    r(this, "params");
    this.id = (t == null ? void 0 : t.id) ?? w.RENEW, this.contractId = t == null ? void 0 : t.contractId, this.phone = t == null ? void 0 : t.phone, this.clientType = t == null ? void 0 : t.clientType, this.nbTerms = t == null ? void 0 : t.nbTerms, this.params = t;
  }
  clone() {
    return new j(this.params);
  }
  getData() {
    return {
      id: this.id,
      contractId: this.contractId,
      phone: this.phone,
      clientType: this.clientType,
      nbTerms: this.nbTerms
    };
  }
}
class st {
  constructor(e) {
    r(this, "adresse");
    r(this, "methodInfo");
    r(this, "pickup");
    r(this, "appointment");
    r(this, "prix");
    r(this, "libelle");
    r(this, "gencode");
    this.adresse = e.adresse, this.methodInfo = e.methodInfo, this.pickup = e.pickup, this.appointment = e.appointment, this.prix = e.prix, this.libelle = e.libelle, this.gencode = e.gencode;
  }
  getApiData() {
    const e = {
      gencode: this.gencode
    };
    return this.pickup && (this.pickup.deliveryType === Me.CLICK_AND_COLLECT ? e.entiteReseauDistribution = {
      codeEnseigne: this.pickup.brandId,
      nom: this.pickup.name,
      codePointVente: this.pickup.rvc
    } : (e.pointRelais = {
      codeIdentification: this.pickup.id,
      libelle: this.pickup.name
    }, this.pickup.rvc && (e.pointRelais.codeSecteurLivraison = this.pickup.rvc))), this.appointment && (e.creneauChoisi = this.appointment), e;
  }
}
class rt {
  constructor(e) {
    r(this, "idCart");
    r(this, "fundingMethods");
    r(this, "pathway");
    this.idCart = e.idCart, this.fundingMethods = e.fundingMethods || [], this.pathway = e.pathway || [];
  }
}
class B {
  constructor(e) {
    r(this, "label");
    r(this, "fullLabel");
    r(this, "paymentModes");
    r(this, "commercialProposal");
    r(this, "type");
    r(this, "position");
    this.label = e.label, this.fullLabel = e.fullLabel, this.paymentModes = e.paymentModes, this.commercialProposal = e.commercialProposal ?? [], this.type = e.type, this.position = e.position;
  }
}
class _e {
  constructor(e) {
    r(this, "address");
    r(this, "context");
    r(this, "forms");
    r(this, "id");
    r(this, "products");
    r(this, "totals");
    r(this, "lastProductParamsSent");
    r(this, "idOpportunity");
    this.address = e.address, this.context = e.context.clone(), this.forms = e.forms ?? {}, this.id = e.id, this.products = (e.products ?? []).map((t) => t.clone()), this.totals = e.totals, this.lastProductParamsSent = e.lastProductParamsSent, this.idOpportunity = e.idOpportunity;
  }
  clone() {
    return new _e({
      address: this.address,
      context: this.context.clone(),
      products: this.products.map((e) => e.clone())
    });
  }
  addFormData(e) {
    const t = this.forms;
    Object.keys(e).forEach((i) => t[i] = e[i]), this.forms = t;
  }
  calculateTotals() {
    return {
      daily: this.products.filter((e) => e.priceType === P.TODAY).reduce((e, t) => e.add(t.prices), new C()),
      monthly: this.products.filter((e) => e.priceType === P.EVERY_MONTH).reduce((e, t) => e.add(t.prices), new C()),
      reported: this.products.filter((e) => e.priceType === P.REPORTED).reduce((e, t) => e.add(t.prices), new C())
    };
  }
  /**
   * Retrieve principal product by type
   */
  getPrincipalProduct(e) {
    return this.getProductsByType(e).find((t) => t.isPrincipal);
  }
  /**
   * Return a specific product by gencode from quote
   */
  getProductByGencode(e) {
    return this.products.find((t) => e === t.data.gencode);
  }
  /**
   * Return all products by gencode from quote
   */
  getProductsByGencodes(e) {
    return this.products.filter((t) => e.includes(t.data.gencode));
  }
  /**
   * Return first product by class type for a specific quote
   */
  getProductByType(e) {
    const t = this.getProductsByType(e);
    return t.length ? t[0] : null;
  }
  /**
   * Return all products by class type for a specific quote
   */
  getProductsByType(e, t = !1) {
    return this.products.filter((i) => m.Is(i, e, t));
  }
  /**
   * Check if quote contains a valid combination of products
   * @return Boolean
   */
  checkIsValid() {
    const e = this.getPrincipalProduct(a._subscription), t = e == null ? void 0 : e.rules.mandatory.find(
      (i) => this.products.filter((s) => m.Is(s, i.product)).length === 0
    );
    if (t)
      throw new Error(t.message);
    return !0;
  }
  isAcquisition() {
    return this.context instanceof x;
  }
  isAcquisitionFix() {
    return this.context instanceof K;
  }
  isPreorder() {
    var t, i;
    const e = this.getPrincipalProduct(a.phone);
    return !!((t = e == null ? void 0 : e.data) != null && t.is_preorder && ((i = e == null ? void 0 : e.data) != null && i.in_stock));
  }
  isRenewal() {
    return this.context instanceof j;
  }
  hasProProduct() {
    return this.products.some((e) => e.isPro);
  }
}
const Ge = Symbol.for("constructDateFrom");
function Ve(o, e) {
  return typeof o == "function" ? o(e) : o && typeof o == "object" && Ge in o ? o[Ge](e) : o instanceof Date ? new o.constructor(e) : new Date(e);
}
function ot(o, e) {
  return Ve(o, o);
}
function nt(o, e, t) {
  const i = ot(o);
  return isNaN(e) ? Ve(o, NaN) : (i.setDate(i.getDate() + e), i);
}
class M {
  constructor(e) {
    r(this, "data");
    r(this, "gencode");
    r(this, "id");
    r(this, "isPrincipal", !1);
    r(this, "position", 0);
    r(this, "manufacturer");
    r(this, "title");
    r(this, "name");
    r(this, "rules", {
      incompatible: [],
      related: [],
      mandatory: [],
      maxQuantity: 0
    });
    r(this, "total", 0);
    r(this, "productLine", "Autres");
    r(this, "gamme", "");
    r(this, "prices");
    r(this, "priceType", P.EVERY_MONTH);
    r(this, "promotions", new g([], [], []));
    r(this, "autoAdd", []);
    r(this, "medias", []);
    r(this, "image");
    r(this, "smallImage");
    r(this, "imageHD");
    r(this, "maxQty");
    r(this, "isPro", !1);
    r(this, "wallurl");
    r(this, "proLabel", "");
    r(this, "label");
    r(this, "minPromoPrice", 0);
    r(this, "crossSells", []);
    r(this, "upSells", []);
    r(this, "related", []);
    r(this, "categories", []);
    r(this, "essential", !1);
    r(this, "autoAddFront");
    this.data = e, this.gencode = e.gencode, this.manufacturer = e.manufacturer, this.title = e.title, this.name = e.name, this.medias = e.medias ?? [], this.autoAdd = e.auto_add_front ? e.auto_add_front.split(",") : [], this.autoAddFront = e.to_add_front ? JSON.parse(e.to_add_front) : [], this.prices = new C(e.price), this.image = e.image, this.smallImage = e.small_image, this.imageHD = e.imageHd, this.maxQty = e.max_qty, this.wallurl = e.type_id, this.label = e.name, this.crossSells = e.crossSellsProducts ? e.crossSellsProducts.map((t) => typeof t != "string" ? t.gencode : t) : [], this.upSells = e.upSellsProducts ? e.upSellsProducts.map((t) => typeof t != "string" ? t.gencode : t) : [], this.related = e.relatedProduct ?? [], this.categories = e.categories ?? [], this.setRules();
  }
  canAdd(e) {
    if (this.rules.maxQuantity && e.products.filter(
      (i) => i.data.type_id === this.data.type_id
    ).length + 1 > this.rules.maxQuantity)
      throw new Error(
        `Vous avez atteint la limite autorisée (${this.rules.maxQuantity}) pour ce type de produit`
      );
    if (this.data.max_qty && e.products.filter(
      (i) => !this.rules.incompatible.includes(
        a[i.data.type_id]
      ) && i.data.gencode === this.data.gencode
    ).length + 1 > this.data.max_qty)
      throw new Error(`Vous avez atteint la limite autorisée (${this.data.max_qty}) pour ce type de produit`);
    return !0;
  }
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  beforeAdd(e, t) {
  }
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  afterAdd(e, t) {
  }
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  afterRemove(e, t) {
  }
  getIncompatible(e) {
    return this.rules.incompatible.reduce((t, i) => {
      const s = e.getProductsByType(i, !0);
      return [...t, ...s];
    }, []);
  }
  getRelated(e) {
    return [
      ...this.rules.related.map((t) => e.getProductsByType(t)).reduce((t, i) => (i.forEach((s) => t.add(s)), e.products.filter(
        (s) => this.crossSells.includes(s.gencode) || this.upSells.includes(s.gencode)
      ).forEach((s) => t.add(s)), t), /* @__PURE__ */ new Set())
    ];
  }
  /**
   * Retrieve products that should be automatically added to the quote
   * @param quote currentQuote
   * @returns Array of product
   */
  getAutoAdded(e) {
    const t = /* @__PURE__ */ new Set();
    return this.autoAddFront.forEach((i) => {
      i.alternatives.forEach((s) => {
        const n = e.getProductByGencode(s);
        n && t.add(n);
      });
    }), Array.from(t);
  }
  // @ts-ignore
  keepProduct(e, t) {
    return this.crossSells.includes(t.gencode);
  }
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onItemAddedInQuote(e, t) {
  }
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onItemRemovedFromQuote(e, t) {
  }
  // @ts-ignore
  calculatePrices(e, t) {
    this.promotions = t, this.prices = this.promotions.getPrices(this.prices.base, this.minPromoPrice);
  }
  refresh(e, t) {
    this.removeProductByPromotions(e, t);
  }
  getPrice() {
    return this.prices.final;
  }
  isInStock() {
    return this.data.in_stock;
  }
  clone() {
    return new this.constructor(this.data);
  }
  removeProductByPromotions(e, t) {
    t.getProductsByType(a.edp) && !this.promotions.canHaveEdp() && e.removeProductsByType(t, a.edp);
  }
  setRules() {
  }
}
class oe extends M {
  constructor(t, i) {
    super(t);
    r(this, "iconInfos");
    this.data = t, this.priceType = P.EVERY_MONTH, this.iconInfos = i;
  }
  updatePromotions() {
  }
}
const k = class k extends oe {
  constructor(t) {
    super({
      ...t,
      name: "Assurance"
    });
    r(this, "productLine", "Assurance");
  }
  setRules() {
    super.setRules(), this.rules.incompatible = k.INCOMPATIBLE_PRODUCTS, this.rules.mandatory = k.MANDATORY_PRODUCTS;
  }
};
r(k, "INCOMPATIBLE_PRODUCTS", [a.insurance]), r(k, "MANDATORY_PRODUCTS", [
  {
    product: a._equipement,
    message: "Une assurance doit être ajoutée sur un équipement."
  }
]);
let ue = k;
const pe = class pe extends oe {
  constructor(t) {
    super(t);
    r(this, "isPrincipal", !1);
    r(this, "productLine", "Options");
    r(this, "category");
    r(this, "promoCodePrice");
    this.isPro = t.exclu_pro ?? !1, this.category = t.option_category, this.promoCodePrice = t.code_promo_price ? Number(t.code_promo_price) : 0;
  }
  setRules() {
    super.setRules(), this.rules.mandatory = this.rules.mandatory.concat(pe.MANDATORY_PRODUCTS);
  }
};
r(pe, "MANDATORY_PRODUCTS", [
  {
    product: a._plan,
    message: "Une option doit être ajoutée sur un forfait."
  }
]);
let b = pe;
class at extends b {
}
class ct extends b {
}
class ut extends b {
}
class lt extends b {
}
const D = class D extends oe {
  constructor(t, i = !1) {
    var s;
    super(t, { name: "forfait-byou" });
    r(this, "isPremium", !1);
    r(this, "isPrincipal", !0);
    r(this, "portability");
    r(this, "portabilityEnable");
    r(this, "options");
    r(this, "isAssos", !1);
    r(this, "productPrio");
    this.data = t, this.isPro = i, this.portabilityEnable = !1, this.isPro = t.exclu_pro || !1, this.isAssos = t.exclu_assos ?? !1, this.label = (s = t.categories) != null && s.some((n) => D.categoriesSet.has(n)) ? this.data.name : `Forfait ${this.data.name}`, this.proLabel = `Forfait Pro ${this.data.name}`, this.productPrio = t.produit_prioritaire;
  }
  setRules() {
    super.setRules(), this.rules.incompatible = this.rules.incompatible.concat(D.INCOMPATIBLE_PRODUCTS), this.rules.related = this.rules.related.concat(D.RELATED_PRODUCTS);
  }
};
r(D, "INCOMPATIBLE_PRODUCTS", [
  a.plan_sowo,
  a.plan_simo,
  a.plan_omb,
  a.plan_premium,
  a.faim,
  a.fai,
  a.faim_premium,
  a.faim_unlimited,
  a.plan_ideo
]), r(D, "RELATED_PRODUCTS", [a.option, a.sim]), r(D, "categoriesSet", /* @__PURE__ */ new Set(["fai", "faim_unlimited"]));
let I = D;
const me = class me extends I {
  constructor() {
    super(...arguments);
    r(this, "iconInfos", { name: "B&You" });
    r(this, "isPrincipal", !0);
    r(this, "productLine", "Forfaits_mobile");
    r(this, "gamme", "B&You");
  }
  setRules() {
    super.setRules(), this.rules.incompatible = I.INCOMPATIBLE_PRODUCTS.concat(me.INCOMPATIBLE_PRODUCTS);
  }
};
r(me, "INCOMPATIBLE_PRODUCTS", [a.box]);
let q = me;
const fe = class fe extends q {
  constructor() {
    super(...arguments);
    r(this, "iconInfos", { name: "Internet pour clé 4G" });
    r(this, "hasPorta", !1);
    r(this, "productLine", "Forfaits_mobile");
    r(this, "gamme", "Faim");
  }
  setRules() {
    super.setRules(), this.rules.incompatible = I.INCOMPATIBLE_PRODUCTS.concat(fe.INCOMPATIBLE_PRODUCTS);
  }
};
r(fe, "INCOMPATIBLE_PRODUCTS", [a.phone]);
let we = fe;
class dt extends q {
  constructor(t) {
    super(t);
    r(this, "iconInfos", { name: "Prompto" });
    r(this, "isPrincipal", !0);
    r(this, "productLine", "Forfaits_mobile");
    r(this, "gamme", "Prompto");
    t.type_id = "plan_omb", t.type = "plan_omb", this.wallurl = "plan_omb";
  }
}
class qe extends q {
  constructor(t) {
    super(t);
    r(this, "iconInfos", { name: "Sensation" });
    r(this, "isPrincipal", !0);
    r(this, "productLine", "Forfaits_mobile");
    r(this, "gamme", "Sensation_SIM_seule");
    t.type_id = "plan_simo", t.type = "plan_simo", this.wallurl = "plan_simo";
  }
}
const S = class S extends I {
  constructor(t) {
    super(t);
    r(this, "isPrincipal", !0);
    r(this, "productLine", "FAI");
    r(this, "play");
    r(this, "technology");
    r(this, "range");
    r(this, "wallurl");
    r(this, "equipment");
    r(this, "commercial_partner");
    this.data = t, this.play = t.play, this.technology = t.technology ?? "", this.range = t.range, this.isPro = t.fai_category_type === "offre_pro", this.wallurl = `${this.data.type_id}_result`, this.equipment = this.data.equipment, this.play = t.play, this.commercial_partner = t.commercial_partner || "none";
  }
  getLabelDaily() {
    return "Frais de mise en services";
  }
  setRules() {
    super.setRules(), this.rules.incompatible = I.INCOMPATIBLE_PRODUCTS.concat(S.INCOMPATIBLE_PRODUCTS), this.rules.related = I.RELATED_PRODUCTS.concat(S.RELATED_PRODUCTS);
  }
};
r(S, "RANGES", {
  BTL: "btl",
  LARGE: "large",
  MEDIUM: "medium",
  MIAMI: "miami",
  MIAMI_PLUS: "miami_plus",
  SENSATION: "sensation",
  SMALL: "small",
  STANDARD: "standard",
  BBOX_SMART_TV: "bbox_smart_tv",
  BBOX_SMART_TV_LARGE: "bbox_smart_tv_large",
  SL_LARGE: "sl_large",
  SL_LARGE_SMART_TV: "sl_large_smart_tv"
}), r(S, "TECHNOLOGIES", {
  ADSL: "ADSL",
  VDSL: "VDSL",
  XDSL: "XDSL",
  THD: "THD",
  FTTH: "FTTH",
  FTTLA: "FTTLA",
  BOX_4G: "BOX_4G",
  BOX_5G: "BOX_5G"
}), r(S, "INCOMPATIBLE_PRODUCTS", [a.box, a.phone]), r(S, "RELATED_PRODUCTS", [
  a.fai_service,
  a.fai_fmd,
  a.fai_box_generique
]);
let le = S;
class ht extends le {
  constructor(t) {
    super(t);
    r(this, "hasPorta", !1);
    r(this, "range");
    this.data = t, this.play = "1P", this.technology = this.equipment = t.technology, this.range = t.classification;
  }
}
const R = class R extends I {
  constructor() {
    super(...arguments);
    r(this, "iconInfos", { name: "Sensation" });
    r(this, "isPrincipal", !0);
    r(this, "isPremium", !0);
    r(this, "productLine", "Forfaits_mobile");
    r(this, "gamme", "Sensation_Avantages_Smartphone");
  }
  setRules() {
    super.setRules(), this.rules.related = this.rules.related.concat(R.RELATED_PRODUCTS), this.rules.incompatible = this.rules.incompatible.concat(R.INCOMPATIBLE_PRODUCTS), this.rules.mandatory = this.rules.mandatory.concat(R.MANDATORY_PRODUCTS);
  }
};
r(R, "MANDATORY_PRODUCTS", [
  {
    product: a.phone,
    message: "Le forfait Sensation Avantages Smartphone requiert un Téléphone."
  }
]), r(R, "INCOMPATIBLE_PRODUCTS", [a.box]), r(R, "RELATED_PRODUCTS", [a.phone, a.box]);
let se = R;
const Q = class Q extends se {
  constructor() {
    super(...arguments);
    r(this, "iconInfos", { name: "Internet pour clé 4G" });
    r(this, "isPremium", !0);
    r(this, "hasPorta", !1);
    r(this, "productLine", "Forfaits_mobile");
  }
  setRules() {
    super.setRules(), this.rules.incompatible = Q.INCOMPATIBLE_PRODUCTS, this.rules.mandatory = Q.MANDATORY_PRODUCTS;
  }
};
r(Q, "MANDATORY_PRODUCTS", [
  {
    product: a.box,
    message: "Le forfait Faim Premium requiert une Box."
  }
]), r(Q, "INCOMPATIBLE_PRODUCTS", [
  a.plan_premium,
  a.plan_sowo,
  a.plan_omb,
  a.plan_simo,
  a.faim,
  a.phone,
  a.fai,
  a.faim_premium,
  a.faim_unlimited
]);
let De = Q;
class pt extends se {
  constructor() {
    super(...arguments);
    r(this, "iconInfos", { name: "Ideo" });
    r(this, "isPrincipal", !0);
    r(this, "productLine", "Forfaits_mobile");
    r(this, "gamme", "Ideo");
  }
}
const Y = class Y extends b {
  constructor(e) {
    super({
      ...e,
      type_id: "edpFms",
      type: "edpFms"
    });
  }
  setRules() {
    super.setRules(), this.rules.mandatory = this.rules.mandatory.concat(Y.MANDATORY_PRODUCTS), this.rules.incompatible = this.rules.incompatible.concat(Y.INCOMPATIBLE_PRODUCTS);
  }
};
r(Y, "MANDATORY_PRODUCTS", [
  {
    product: a.fai_service,
    message: "Ajout impossible."
  }
]), r(Y, "INCOMPATIBLE_PRODUCTS", [a.edpFms]);
let Se = Y;
const v = class v extends oe {
  constructor(t) {
    super(v.prefillData(t));
    r(this, "export", !1);
    r(this, "isPrincipal", !1);
  }
  /**
   * Allows pre-filled data when creating an instace, no any
   * @memberof Edp
   */
  static prefillData(t = {}) {
    return {
      auto_add_front: "",
      duration: 0,
      edp_price: 0,
      incompatible_with: [],
      max_qty: 0,
      price: 0,
      ...t,
      name: "Facilité de paiement du téléphone",
      ecotax: 0,
      entity_id: "0",
      type_id: "edp",
      type: "edp",
      sku: "EPD0000000",
      qty: 0,
      gencode: "EPD0000000",
      position: void 0,
      iconInfos: { name: "" },
      final_price: 1,
      in_stock: !0,
      url: "",
      url_key: ""
    };
  }
  beforeAdd(t, i) {
    super.beforeAdd(t, i);
    const s = i.getProductByType(a.phone);
    if (!s)
      return;
    const n = s.getEdpData(i);
    n && (this.data.duration = n.edp.duration, this.data.edp_price = n.edp.amount, this.data.price = n.edp.amount), this.prices = new C(this.data.edp_price, this.data.edp_price, this.data.edp_price, this.data.duration), this.data.name = `Facilité de paiement du téléphone pendant ${this.data.duration} mois`;
  }
  getPriceMonthly() {
    return this.data.price;
  }
  setRules() {
    super.setRules(), this.rules.mandatory = this.rules.mandatory.concat(v.MANDATORY_PRODUCTS), this.rules.incompatible = this.rules.incompatible.concat(v.INCOMPATIBLE_PRODUCTS);
  }
};
r(v, "MANDATORY_PRODUCTS", [
  {
    product: a._equipement,
    message: "Pas d'EDP sans équipement possible."
  }
]), r(v, "INCOMPATIBLE_PRODUCTS", [a.edp]);
let de = v;
const $ = class $ extends M {
  constructor(t) {
    super(t);
    r(this, "childGencode", []);
    r(this, "color");
    r(this, "colorCode");
    r(this, "title");
    r(this, "capacity");
    r(this, "insurance");
    r(this, "maxConnection");
    r(this, "manufacturer");
    r(this, "minPromoPrice", 1);
    this.data = t, this.priceType = P.TODAY, this.manufacturer = t.manufacturer, this.maxConnection = t.max_connection, this.childGencode = t.product_ids ?? this.childGencode, this.color = t.color, this.colorCode = t.color_code, this.title = t.title, this.capacity = t.capacity, this.insurance = t.insurance ? new ue(t.insurance) : void 0;
  }
  setRules() {
    this.rules.related = this.rules.related.concat($.RELATED_PRODUCTS), this.rules.incompatible = this.rules.incompatible.concat($.INCOMPATIBLE_PRODUCTS);
  }
};
r($, "INCOMPATIBLE_PRODUCTS", []), r($, "RELATED_PRODUCTS", [a.insurance]);
let T = $;
const X = class X extends T {
  constructor(t) {
    super(t);
    r(this, "rsfAmount");
    r(this, "rsfPdf");
    r(this, "isPrincipal");
    r(this, "productLine");
    r(this, "availableEdp");
    r(this, "priceContext", {});
    this.data = t, this.priceContext[w.ACQUISITION] = "acquisition", this.priceContext[w.RENEW] = "renew", this.isPro = t.exclu_pro, this.isPrincipal = !0, this.productLine = "Terminaux", this.availableEdp = !1;
  }
  onItemAddedInQuote(t, i) {
    super.onItemAddedInQuote(t, i);
  }
  onItemRemovedFromQuote(t, i) {
    super.onItemRemovedFromQuote(t, i);
  }
  refresh(t, i) {
    this._updateSpecialPrices(i), super.refresh(t, i);
  }
  calculatePrices(t, i) {
    super.calculatePrices(t, i);
  }
  setRules() {
    super.setRules(), this.rules.incompatible = this.rules.incompatible.concat(X.INCOMPATIBLE_PRODUCTS), this.rules.related = T.RELATED_PRODUCTS.concat(X.RELATED_PRODUCTS);
  }
  getEdpData(t) {
    var u, l, h, p;
    const i = t.getProductByType(a._plan), s = t.getProductByType(a.phone);
    if (!s || !i)
      return;
    const n = (u = s.data.prices.plans) == null ? void 0 : u[i.gencode];
    let c;
    if (t.context instanceof j) {
      const f = t.context.nbTerms, E = t.getProductByType(a.plan_sowo);
      if (!f)
        c = E ? this._getEdpPhoneData(s) : this._getEdpPlanData(s, i);
      else {
        const _ = (l = n.renew) == null ? void 0 : l[t.context.clientType];
        c = _ ? _[f] : (p = (h = n.renew) == null ? void 0 : h[te.CLIENT]) == null ? void 0 : p[f], c.edp = n.edp;
      }
    } else n && (c = this._getEdpPlanData(s, i));
    return c;
  }
  _getEdpPhoneData(t) {
    return {
      edp_price: t.data.edp_phone.price,
      price: t.data.edp_phone.price + t.data.edp_phone.amount * t.data.edp_phone.duration,
      edp: t.data.edp_phone
    };
  }
  _getEdpPlanData(t, i) {
    var c;
    const s = (c = t.data.prices.plans) == null ? void 0 : c[i.gencode], n = s.acquisition;
    return n.edp = s.edp, n;
  }
  _updateSpecialPrices(t) {
    if (t.getProductByType(a._plan)) {
      const s = this.getEdpData(t);
      s && (this.rsfPdf = s == null ? void 0 : s.rsfPdf, s != null && s.price ? (this.prices.base = s.price, this.prices.final = s.price, this.rsfAmount = s.rsfAmount ?? 0) : (this.prices.base = this.data.price, this.prices.final = this.data.price));
    }
  }
};
r(X, "INCOMPATIBLE_PRODUCTS", [
  a.faim,
  a.faim_premium,
  a.faim_unlimited,
  a.box,
  a.phone,
  a.fai
]), r(X, "RELATED_PRODUCTS", [a.edp]);
let he = X;
const ge = class ge extends he {
  constructor() {
    super(...arguments);
    r(this, "isPrincipal", !0);
    r(this, "productLine", "FAI");
  }
  setRules() {
    super.setRules(), this.rules.incompatible = T.INCOMPATIBLE_PRODUCTS.concat(ge.INCOMPATIBLE_PRODUCTS);
  }
};
r(ge, "INCOMPATIBLE_PRODUCTS", [
  a.plan_sowo,
  a.plan_premium,
  a.phone,
  a.box,
  a.fai
]);
let Re = ge;
class mt extends T {
  constructor() {
    super(...arguments);
    r(this, "productLine", "Accessoires");
    r(this, "minPromoPrice", 0);
    r(this, "essential", !1);
  }
  setRules() {
    this.rules.related = [], this.rules.incompatible = [], this.rules.maxQuantity = 5;
  }
}
class ft extends T {
  constructor(e) {
    var t;
    super(e), this.data = e, this.minPromoPrice = 0, this.data.type = "activation", this.priceType = (t = this.data) != null && t.price_type ? P.REPORTED : P.TODAY;
  }
  refresh(e, t) {
    t.getProductByType(a.edpFms) ? this.prices.base = 0 : this.prices.base = this.data.price || 0, super.refresh(e, t);
  }
}
const Pe = class Pe extends M {
  constructor(t) {
    super(t);
    r(this, "export", !1);
    this.data = t, this.priceType = P.TODAY;
  }
  static prefillData(t) {
    return {
      incompatible_with: [],
      auto_add_front: "",
      ecotax: 0,
      entity_id: "0",
      final_price: t.prix,
      in_stock: !0,
      max_qty: 1,
      name: t.libelle,
      price: t.prix,
      qty: 1,
      sku: t.gencode,
      type: "Delivery",
      type_id: "shipping",
      url: "",
      url_key: "",
      gencode: t.gencode
    };
  }
  setRules() {
    super.setRules(), this.rules.incompatible = Pe.INCOMPATIBLE_PRODUCTS;
  }
};
r(Pe, "INCOMPATIBLE_PRODUCTS", [a.shipping]);
let re = Pe;
const ye = class ye extends T {
  constructor(t) {
    super(t);
    r(this, "appointment");
    r(this, "technology");
    r(this, "schemeId");
    r(this, "isPrincipal", !0);
    r(this, "productLine", "FAI");
    this.data = t, this.priceType = P.EVERY_MONTH, this.data.type = "faiBox", this.label = "Frais de location", this.wallurl = "fai_result";
  }
  setAppointment(t) {
    this.appointment = t;
  }
  setTechnology(t) {
    this.technology = t;
  }
  setSchemeId(t) {
    this.schemeId = t;
  }
  setRules() {
    this.rules.related = this.rules.related.concat(ye.RELATED_PRODUCTS);
  }
};
r(ye, "RELATED_PRODUCTS", [a.fai, a.faim_unlimited]);
let Ae = ye;
class gt extends T {
  constructor(e) {
    var t;
    super(e), this.data = e, this.priceType = (t = this.data) != null && t.price_type ? P.REPORTED : P.TODAY;
  }
}
class Pt extends M {
  constructor(t) {
    super(t);
    r(this, "priceType", P.OTHER);
    r(this, "name");
    r(this, "brand");
    r(this, "partnerData");
    this.id = t.id, this.name = t.name, this.brand = t.brand, this.partnerData = t.partnerData;
  }
}
const G = class G extends M {
  constructor(t) {
    super(t);
    r(this, "portabilityType", ae.NO_PORTABILITY);
    r(this, "portabilityPrices");
    r(this, "isCompatible");
    this.data = t, this.priceType = P.TODAY;
  }
  setPortabilityPrices(t) {
    return this.portabilityPrices = t, this;
  }
  refresh(t, i) {
    super.refresh(t, i), this.updatePortabilityPrice(i);
  }
  setRules() {
    super.setRules(), this.rules.incompatible = G.INCOMPATIBLE_PRODUCTS, this.rules.mandatory = G.MANDATORY_PRODUCTS;
  }
  updatePortabilityPrice(t) {
    var n, c;
    const i = t.getPrincipalProduct(a._plan);
    (n = i == null ? void 0 : i.portability) != null && n.active ? this.portabilityType = ae.PORTABILITY : this.portabilityType = ae.NO_PORTABILITY;
    let s = this.data.price;
    (c = this.portabilityPrices) != null && c[this.portabilityType] ? (s = this.portabilityPrices[this.portabilityType].price, this.priceType = this.portabilityPrices[this.portabilityType].type ?? P.TODAY) : this.priceType = P.TODAY, this.prices = new C(s);
  }
};
r(G, "INCOMPATIBLE_PRODUCTS", [a.sim]), r(G, "MANDATORY_PRODUCTS", [
  {
    product: a._plan,
    message: "La carte SIM requiert un forfait."
  }
]);
let be = G;
const Te = {
  // type_id          : ProductClass
  [a.accessory]: mt,
  [a.box]: Re,
  [a.edpFms]: Se,
  [a.edp]: de,
  [a.faim]: we,
  [a.faim_premium]: De,
  [a.faim_unlimited]: ht,
  [a.fai_box_generique]: Ae,
  [a.fai]: le,
  [a.fai_service]: ft,
  [a.fai_fmd]: gt,
  [a.insurance]: ue,
  [a.option_fai]: b,
  [a.option_salable]: lt,
  [a.option_partner]: ct,
  [a.option_remise]: ut,
  [a.odr]: at,
  [a.plan_ideo]: pt,
  [a.plan_omb]: dt,
  [a.plan_simo]: qe,
  [a.plan_sowo]: q,
  [a.plan_premium]: se,
  [a.phone]: he,
  [a.sim]: be,
  [a.shipping]: re,
  [a._subscription]: oe,
  [a._equipement]: T,
  [a._plan]: I,
  [a._product]: M,
  [a["mobile-take-back"]]: Pt
};
class m {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static GetInstance(e) {
    const t = e.type_id;
    let i;
    const s = e, n = s.obligation_id ?? s.obligation;
    switch (!0) {
      case (t === "plan_sowo" && n && n !== "none"):
        i = new qe(e);
        break;
      case !!Te[a[t]]:
        i = new Te[a[t]](
          e
        );
        break;
      default:
        throw new Error(`Product type "${e.type_id}" is not set`);
    }
    return i;
  }
  static Is(e, t, i = !1) {
    const s = Te[t];
    if (!s)
      throw new Error(`Type ${t} not define`);
    return i ? e.constructor === s : e instanceof s;
  }
}
class yt {
  async setDelivery(e, t, i, s = t.currentQuoteIndex) {
    const n = new re(
      re.prefillData({
        libelle: i.libelle,
        prix: i.prix,
        gencode: i.gencode
      })
    );
    try {
      return await e.addProduct(n, s);
    } finally {
      this._save(e, t, i, s);
    }
  }
  getDelivery(e, t = e.currentQuoteIndex) {
    var s;
    const i = (s = e.getQuote(t).forms) == null ? void 0 : s.deliveryInfo;
    return i ? new st(i) : null;
  }
  async removeDelivery(e, t, i) {
    var s;
    if (!m.Is(t, a.shipping) && !m.Is(t, a.edp)) {
      const c = e.cart.getQuote(i).getProductByType(a.shipping);
      if (c)
        return (s = e.cart.getQuote(i).forms) != null && s.deliveryInfo && delete e.cart.getQuote(i).forms.deliveryInfo, await e.removeProduct(c, i, !1);
    }
    return t;
  }
  _save(e, t, i, s = t.currentQuoteIndex) {
    t.getQuote(s).addFormData({
      deliveryInfo: i
    }), e.save();
  }
}
const Z = class Z {
  constructor(e) {
    r(this, "subscription");
    r(this, "equipment");
    r(this, "cartService");
    this.cartService = e;
  }
  get paymentMethods() {
    return Object.keys(Z.ALLOWED_PAYMENT_METHODS).map((e) => Z.ALLOWED_PAYMENT_METHODS[e]);
  }
  hasEdp(e) {
    return e.quotes.some((t) => !!t.getProductByType(a.edp));
  }
  async addEdpProduct(e, t = e.currentQuoteIndex) {
    const i = new de();
    return await this.cartService.addProduct(i, t), !0;
  }
  async removeEdpProduct(e, t = e.currentQuoteIndex) {
    const i = e.getQuote(t).getProductByType(a.edp);
    return i ? (await this.cartService.removeProduct(i, t), !0) : !1;
  }
  isEdpAllowed(e) {
    return e == null ? void 0 : e.some((t) => t.type === d.MULTI_PRODUCT);
  }
  async checkEdpWithCoupon(e, t) {
    const i = e.promotions.coupon;
    if (this.isCouponCompatibleWithEdp(t, i))
      return t;
    throw new Error("Coupon is not compatible with EDP");
  }
  isCouponCompatibleWithEdp(e, t) {
    return !e || !t || t.isEligibleEdp;
  }
};
r(Z, "ALLOWED_PAYMENT_METHODS", {
  CASH: {
    label: "Comptant",
    method: "CASH"
  },
  SPREAD: {
    label: "Facilité de paiement",
    method: "SPREAD"
  }
});
let Fe = Z;
class _t {
  constructor() {
    r(this, "_storageKey", "checkout_cart");
  }
  saveCart(e) {
    const t = this.getCart(), i = e.quotes.map((n) => this._getDataToStore(n)), s = {
      ...t,
      cartId: e.cartId,
      coupon: e.coupon,
      type: e.type,
      userId: e.userId,
      currentQuote: e.currentQuoteIndex,
      quotes: i,
      isPro: e.isPro,
      isComingFromProWall: e.isComingFromProWall,
      lastProductParamsSent: e.lastProductParamsSent,
      promotions: e.promotions,
      fundingMethod: e.fundingMethod
    };
    typeof localStorage > "u" || localStorage == null || localStorage.setItem(this._storageKey, JSON.stringify({ data: s }));
  }
  getCart() {
    if (typeof localStorage > "u")
      return;
    const e = localStorage.getItem(this._storageKey);
    return e || localStorage.removeItem(this._storageKey), e ? JSON.parse(e).data : void 0;
  }
  initCartFromStorage(e) {
    const t = this.getCart();
    if (t) {
      const i = t.promotions ?? new g([], [], []);
      e.cartId = t.cartId, e.coupon = t.coupon, e.type = t.type, e.userId = t.userId, e.configId = t.configId || "", e.currentQuoteIndex = t.currentQuote, e.isPro = t.isPro, e.isComingFromProWall = t.isComingFromProWall, e.lastProductParamsSent = t.lastProductParamsSent, e.promotions = i, e.isPro = t.isPro, e.isComingFromProWall = t.isComingFromProWall, e.lastProductParamsSent = t.lastProductParamsSent, e.fundingMethod = t.fundingMethod;
      const s = i.manual.map((c) => new V(c)), n = i.coupon ? new V(i.coupon) : void 0;
      return e.promotions = new g([], s, [], n), t.quotes && t.quotes.forEach((c) => {
        var l;
        const u = new _e({
          id: c.id,
          products: [],
          address: c.address,
          forms: c.forms ?? {},
          lastProductParamsSent: c.lastProductParamsSent,
          context: new Ht().initContextFromStorage(c.context)
        });
        (l = c.products) == null || l.forEach((h) => {
          const p = m.GetInstance(h.data);
          p && (p.id = h.id, this.setProductData(h, p), u.products.push(p));
        }), e.quotes.push(u);
      }), !0;
    }
    return !1;
  }
  setProductData(e, t) {
    Object.keys(e).forEach((s) => {
      t[s] = e[s];
    }), t.promotions && (t.promotions = new g(
      t.promotions.automatic,
      t.promotions.manual,
      t.promotions.incitation
    ));
  }
  _getDataToStore(e) {
    var t;
    return {
      address: e.address,
      context: (t = e.context) == null ? void 0 : t.getData(),
      forms: e.forms,
      id: e.id,
      products: e.products,
      lastProductParamsSent: e.lastProductParamsSent
    };
  }
}
function O(o) {
  let e = {
    "Cache-Control": "cache-js",
    "Content-Type": "application/json"
  };
  return o.xSource && (e = { ...e, "x-source": o.xSource }), o.salesApiVersion && (e = { ...e, "x-version": o.salesApiVersion }), o.xBanc && (e = { ...e, "x-banc": o.xBanc }), e;
}
function Ce(o) {
  let e = {
    "Cache-Control": "cache-js",
    "Content-Type": "application/json"
  };
  return o != null && o.xSource && (e = { ...e, "x-source": o.xSource }), o != null && o.xBanc && (e = { ...e, "x-banc": o.xBanc }), e;
}
async function Ct(o, e, t) {
  const i = await fetch(`${o.resourceUrl}/ventes/paniers/eligibilite-promotionnelle`, {
    method: "POST",
    headers: { ...O(o), ...t },
    body: JSON.stringify(e)
  });
  if (!i.ok)
    throw new Error("Error while fetching coupon eligibility");
  return i.json();
}
async function It(o, e, t, i) {
  const s = await fetch(`${o.resourceUrl}/ventes/paniers/${e}/promotions/${t}`, {
    method: "DELETE",
    headers: { ...O(o), ...i }
  });
  if (!s.ok)
    throw new Error("Error while deleting coupon");
  return s.json();
}
async function Tt(o, e, t) {
  const i = await fetch(`${o.resourceUrl}/contrats/${e}`, {
    headers: { ...Ce(o), ...t }
  });
  if (!i.ok)
    throw new Error("Error while fetching contract");
  const s = await i.json(), n = await We(o, s.abonnement.idOffre, t);
  return s.isSowo = m.Is(m.GetInstance(n), a.plan_sowo), s;
}
async function Ot(o, e, t) {
  const i = await fetch(`${o.resourceUrl}/contrats/${e}/options`, {
    headers: { ...Ce(o), ...t }
  });
  if (!i.ok)
    throw new Error("Error while fetching contract options");
  return i.json();
}
async function Et(o, e, t) {
  const i = await fetch(`${o.resourceUrl}/contrats/${e}/lignes`, {
    headers: { ...Ce(o), ...t }
  });
  if (!i.ok)
    throw new Error("Error while fetching contract lines");
  return i.json();
}
async function wt(o, e, t) {
  const i = await fetch(`${o.resourceUrl}/contrats/${e}/eligibilites-renouvellement`, {
    headers: { ...Ce(o), ...t }
  });
  if (!i.ok)
    throw new Error("Error while fetching contract eligibility");
  return i.json();
}
function Dt(o) {
  const e = {
    MONTH12: { LABEL: A.MONTH12, DIFF: 0 },
    MONTH18: { LABEL: A.MONTH18, DIFF: 6 },
    MONTH24: { LABEL: A.MONTH24, DIFF: 12 }
  }, t = o == null ? void 0 : o.items[0];
  let i = e.MONTH12.LABEL;
  const s = /* @__PURE__ */ new Date(), n = t != null && t.dateTarifPreferentiel ? new Date(t.dateTarifPreferentiel) : new Date(s.getTime()), c = t != null && t.dateTarifPreferentielIntermediaire ? new Date(t.dateTarifPreferentielIntermediaire) : new Date(s.getTime());
  return s > n ? i = e.MONTH24.LABEL : s > c && (i = e.MONTH18.LABEL), i;
}
async function St(o, e, t, i) {
  let s;
  t && (s = { attribute: t });
  const n = s ? "?" + new URLSearchParams(s).toString() : "", c = await fetch(`${o.resourceUrl}/ventes/produits/${e}${n}`, {
    headers: { ...O(o), ...i }
  });
  if (!c.ok)
    throw new Error("Error while fetching product");
  return c.json();
}
async function je(o, e, t = {}) {
  const i = e.join(","), s = await fetch(`${o.resourceUrl}/ventes/produits?listGencode=${i}`, {
    headers: { ...O(o), ...t }
  });
  if (!s.ok)
    throw new Error("Error while fetching products");
  return (await s.json()).produits;
}
async function We(o, e, t) {
  const i = await je(o, [e], t);
  return i[Object.keys(i)[0]];
}
async function Rt(o, e, t = !1, i = !0, s) {
  const n = new URLSearchParams({
    categories: e.join(","),
    withDetails: t.toString(),
    show_products: i.toString()
  }), c = await fetch(`${o.resourceUrl}/ventes/categories?${n.toString()}`, {
    headers: {
      ...O(o),
      ...s
    }
  });
  if (!c.ok)
    throw new Error("Error while fetching categories");
  return (await c.json()).categories;
}
class At {
  constructor(e) {
    r(this, "config");
    this.config = e;
  }
  getProductCategories(e, t = !1, i = !0) {
    return Rt(this.config, e, t, i);
  }
  /**
   *
   * @return Promise of JsonProduct
   *
   */
  getProductByAttribute(e, t) {
    return St(this.config, e, t);
  }
  async getProductByGencode(e) {
    return We(this.config, e);
  }
  async getProductsByGencodes(e) {
    return Object.values(await je(this.config, e));
  }
}
class bt {
  constructor(e) {
    r(this, "checkoutStorage");
    this.checkoutStorage = e;
  }
  getEligibility() {
    return this.checkoutStorage.get("eligibility", !1);
  }
}
async function Ft(o, e, t) {
  const i = await fetch(`${o.resourceUrl}/ventes/paniers/${e}/modes-financement/courant`, {
    headers: {
      ...O(o),
      ...t
    }
  });
  if (!i.ok)
    throw new Error("Error while fetching funding methods");
  return i.json();
}
async function vt(o, e, t = {}, i) {
  t = new URLSearchParams(t);
  const s = await fetch(
    `${o.resourceUrl}/ventes/paniers/${e}/modes-financement?${t.toString()}`,
    {
      headers: {
        ...O(o),
        ...i
      }
    }
  );
  if (!s.ok)
    throw new Error("Error while fetching funding methods");
  return s.json();
}
async function Lt(o, e, t = {}, i) {
  t = new URLSearchParams(t);
  const s = await fetch(
    `${o.resourceUrl}/ventes/paniers/${e}/modes-financement?${t.toString()}`,
    {
      headers: {
        ...O(o),
        ...i
      },
      method: "POST"
    }
  );
  if (!s.ok)
    throw new Error("Error while fetching funding methods");
  return s.json();
}
async function xt(o, e = {}, t) {
  const i = await fetch(`${o.resourceUrl}/referentiel/modes-financement`, {
    headers: {
      ...O(o),
      ...t
    },
    method: "POST",
    body: JSON.stringify(e)
  });
  if (!i.ok)
    throw new Error("Error while fetching funding methods");
  return i.json();
}
class Mt {
  constructor(e, t) {
    r(this, "PAYMENT_MODES_DETAILS", [
      {
        id: "CB",
        value: "CB",
        icon: "credit-card",
        position: 0
      },
      {
        id: "PAYPAL",
        value: "PAYPAL",
        icon: "icon-cb-paypal",
        position: 1
      },
      {
        id: "COFIDIS_X3",
        value: "CREDIT_X3",
        label: "Paiement en 3 fois sans frais"
      },
      {
        id: "COFIDIS_X12",
        value: "CREDIT_MENSUEL"
      },
      {
        id: "COFIDIS_X24",
        value: "CREDIT_MENSUEL"
      },
      {
        id: "YOUNITED",
        value: "YOUNITED"
      },
      {
        id: "HYBRIDE",
        value: "HYBRIDE",
        position: 4
      },
      {
        id: "SANS_PAIEMENT",
        value: "SANS_PAIEMENT"
      },
      {
        id: "EDP",
        value: "EDP"
      }
    ]);
    r(this, "FUNDING_COOKIE", "younited_credit");
    r(this, "YOUNITED_UNWANTED_KEY", ["YOUNITED_X3", "YOUNITED_X12", "YOUNITED_X24", "YOUNITED_X36"]);
    r(this, "COFIDIS_UNWANTED_KEY", ["COFIDIS_X12", "COFIDIS_X24", "COFIDIS_X3"]);
    r(this, "cookieStorageService", new it());
    r(this, "config");
    r(this, "user");
    this.config = e, this.user = t;
  }
  setUser(e) {
    this.user = e;
  }
  /**
   * Get funding modes for current cart
   * @param cartId Current cart id
   * @returns Fundings modes
   */
  async getFundingCart(e) {
    const t = { mode: "min-one-off" };
    this._getFundingCookie() && (t.younited_credit = this._getFundingCookie());
    const i = {};
    this.user && (i.Authorization = `Bearer ${this.user.accessToken}`);
    const s = await vt(this.config, e, t, i);
    return this._createFundingCartModel(s);
  }
  async getVirtualCartFundingModes(e, t) {
    if (e.isCartEmpty())
      return;
    const i = { mode: "min-one-off", ...this._getVirtualFundingModesPayload(e, t) };
    this._getFundingCookie() && (i.younited_credit = this._getFundingCookie());
    const s = await xt(this.config, i);
    return this._createFundingCartModel(s == null ? void 0 : s.financements[0]);
  }
  /**
   * Get current funding method with final commercial proposal
   * @param cartId current cartId
   * @returns return final proposal
   */
  async getCurrentFundingMethod(e) {
    const t = await Ft(this.config, e);
    return this._createCurrentFunding(t);
  }
  /**
   * Post funding modes
   * @returns FundingModeReturn object
   */
  async postFundingMode(e, t, i, s) {
    var l, h, p;
    if (!((l = e.fundingMethod) != null && l.type))
      throw new Error("Mode de financement manquant");
    let n = e.fundingMethod.type;
    s && (n = (h = this._getCreditType(e.fundingMethod.type, s.nbLoan)) == null ? void 0 : h.toString());
    const c = {
      modeDeFinancement: n,
      modeDePaiement: this._getPaymentMode(i, e.fundingMethod, s == null ? void 0 : s.nbLoan),
      urlDeRappel: `${window.location.origin}/tunnel/redirect?cartId=${e.cartId}`,
      parcours: ((p = e.fundingMethod) == null ? void 0 : p.type) === d.MULTI_PRODUCT ? t.pathway.map((f) => this._getFundingPathwayApi(e, f)) : void 0
    };
    if (!c.modeDeFinancement || !c.modeDePaiement)
      throw new Error("Mode de financement ou de paiement manquant");
    const u = await Lt(this.config, e.cartId, c);
    return {
      status: u.status,
      callbackUrl: u.url,
      id: u.id
    };
  }
  _createFundingCartModel(e) {
    var n;
    const t = new rt({
      idCart: e.idPanier,
      fundingMethods: this._createFundingModeModel(e),
      pathway: (n = e.parcours) == null ? void 0 : n.map((c) => this._createFundingPathway(c))
    }), i = t.fundingMethods.filter((c) => c.type.toLowerCase().includes("younited"));
    if (i.length > 0) {
      const c = this._mergeYounitedProposals(i);
      t.fundingMethods.push(c), t.fundingMethods = t.fundingMethods.filter(
        (u) => !this.YOUNITED_UNWANTED_KEY.includes(u.type)
      );
    }
    const s = t.fundingMethods.filter((c) => c.type.toLowerCase().includes("cofidis"));
    if (s.length > 0) {
      const c = this._mergeCofidisProposals(s);
      t.fundingMethods.push(c), t.fundingMethods = t.fundingMethods.filter(
        (u) => !this.COFIDIS_UNWANTED_KEY.includes(u.type)
      );
    }
    return t;
  }
  _mergeYounitedProposals(e) {
    var i;
    const t = new B({
      type: d.YOUNITED,
      commercialProposal: [],
      label: this._getFundingMethodLabel(d.YOUNITED),
      fullLabel: Ie[d.YOUNITED].fullLabel,
      paymentModes: (i = e[0]) == null ? void 0 : i.paymentModes,
      position: 2
    });
    return e.forEach((s) => {
      s.commercialProposal.forEach((n) => {
        t.commercialProposal.find((c) => c.nbLoan === n.nbLoan) || t.commercialProposal.push(n);
      });
    }), t.commercialProposal.every((s) => s.tAEG === 0) && (t.label += " 0%"), t;
  }
  _mergeCofidisProposals(e) {
    const t = new B({
      type: d.COFIDIS,
      commercialProposal: [],
      label: this._getFundingMethodLabel(d.COFIDIS),
      fullLabel: Ie[d.COFIDIS].fullLabel,
      paymentModes: [],
      position: 2
    });
    return e.forEach((i) => {
      i.commercialProposal.forEach((s) => {
        t.commercialProposal.find((n) => n.nbLoan === s.nbLoan) || t.commercialProposal.push(s);
      });
    }), t;
  }
  _createFundingPathway(e) {
    var t;
    return {
      idPathway: e.idParcours,
      products: (t = e.produits) == null ? void 0 : t.map((i) => this._createFundingPathwayProduct(i))
    };
  }
  _createFundingPathwayProduct(e) {
    var t;
    return {
      idProduct: e.idProduit,
      gencode: e.gencode,
      cartFundingModes: e.modesDeFinancementPanier,
      productsFundingMode: (t = e.modesDeFinancementProduits) == null ? void 0 : t.map((i) => new B({
        label: this._getFundingMethodLabel(i.type) ?? (i == null ? void 0 : i.libelle),
        paymentModes: this._createPaymentModes(i.modesDePaiement ?? []).filter(
          (s) => s !== void 0
        ),
        commercialProposal: this._createCommercialProposals(i == null ? void 0 : i.propositionsCommerciales),
        type: i == null ? void 0 : i.type
      }))
    };
  }
  /**
   * Transform api data to funding mode model
   * @param data API data
   * @returns Return funding mode model
   */
  _createFundingModeModel(e) {
    var t;
    return (t = e.modesDeFinancement) == null ? void 0 : t.map((i) => new B({
      label: this._getFundingMethodLabel(i.type) ?? (i == null ? void 0 : i.libelle),
      paymentModes: this._createPaymentModes(i.modesDePaiement ?? []).filter(
        (s) => s !== void 0
      ),
      commercialProposal: this._createCommercialProposals(i == null ? void 0 : i.propositionsCommerciales),
      type: i == null ? void 0 : i.type,
      position: this._getFundingMethodPosition(i)
    }));
  }
  _createPaymentModes(e) {
    return e == null ? void 0 : e.map((t) => this.PAYMENT_MODES_DETAILS.find((i) => i.id === t.type)).filter((t) => t);
  }
  /**
   * Create commercial proposal array - for younited in case of multiple proposal
   * for same duration take the on with the cheapest initialAmount
   * @param data api proposals
   * @returns commercial proposal array
   */
  _createCommercialProposals(e) {
    const t = [];
    return e && e.forEach((i) => {
      const s = {
        initialAmount: i.apportInitial,
        fundingFinalCost: i.coutTotalFinancement,
        amountToFund: i.montantAFinancer,
        interestAmount: i.montantInterets,
        monthlyAmount: i.montantMensualite,
        lastMonthlyAmount: i == null ? void 0 : i.dernierMontantMensualite,
        nbLoan: i.nbrEcheances,
        tAEG: i.tAEG,
        fixedRate: i.tauxDebiteurFixe
      };
      t.push(s);
    }), t;
  }
  /**
   * Create funding method from get current API response
   * @param data api response
   * @returns Current funding method with partner status
   */
  _createCurrentFunding(e) {
    var t, i, s, n, c, u, l, h, p, f, E, _, y, U, ne, W, Be, ke, Qe, Ye;
    return {
      id: e.id,
      method: new B({
        label: this._getFundingMethodLabel((t = e.modesDeFinancement) == null ? void 0 : t.type) ?? ((i = e.modesDeFinancement) == null ? void 0 : i.libelle),
        paymentModes: this.PAYMENT_MODES_DETAILS.filter(
          (Je) => {
            var $e;
            return Je.id === (($e = e.modesDeFinancement) == null ? void 0 : $e.modesDePaiement);
          }
        ),
        commercialProposal: ((s = e.status) == null ? void 0 : s.toLowerCase()) === "ok" ? [
          {
            initialAmount: (c = (n = e.modesDeFinancement) == null ? void 0 : n.propositionsCommerciales) == null ? void 0 : c.apportInitial,
            fundingFinalCost: (l = (u = e.modesDeFinancement) == null ? void 0 : u.propositionsCommerciales) == null ? void 0 : l.coutTotalFinancement,
            amountToFund: (p = (h = e.modesDeFinancement) == null ? void 0 : h.propositionsCommerciales) == null ? void 0 : p.montantAFinancer,
            interestAmount: (E = (f = e.modesDeFinancement) == null ? void 0 : f.propositionsCommerciales) == null ? void 0 : E.montantInterets,
            monthlyAmount: (y = (_ = e.modesDeFinancement) == null ? void 0 : _.propositionsCommerciales) == null ? void 0 : y.montantMensualite,
            lastMonthlyAmount: (ne = (U = e.modesDeFinancement) == null ? void 0 : U.propositionsCommerciales) == null ? void 0 : ne.dernierMontantMensualite,
            nbLoan: (Be = (W = e.modesDeFinancement) == null ? void 0 : W.propositionsCommerciales) == null ? void 0 : Be.nbrEcheances,
            tAEG: (Qe = (ke = e.modesDeFinancement) == null ? void 0 : ke.propositionsCommerciales) == null ? void 0 : Qe.tAEG,
            fixedRate: e.modesDeFinancement.propositionsCommerciales.tauxDebiteurFixe
          }
        ] : void 0,
        type: (Ye = e.modesDeFinancement) == null ? void 0 : Ye.type
      }),
      status: e.status,
      reason: e.raison
    };
  }
  _getFundingMethodLabel(e) {
    var t;
    return ((t = Ie[e]) == null ? void 0 : t.label) ?? null;
  }
  _getFundingCookie() {
    return typeof window > "u" ? null : this.cookieStorageService.get(this.FUNDING_COOKIE);
  }
  _getFundingPathwayApi(e, t) {
    return {
      idParcours: t.idPathway,
      produits: this._getFundingProductPostApi(e, t)
    };
  }
  _getFundingProductPostApi(e, t) {
    var c;
    const i = e.fundingMethod;
    let s;
    const n = [];
    if ((i == null ? void 0 : i.type) === d.MULTI_PRODUCT && (s = t.products.find((u) => {
      var l;
      return (l = u.productsFundingMode) == null ? void 0 : l.some((h) => h.type === "EDP");
    }), s)) {
      const u = (c = s.productsFundingMode) == null ? void 0 : c.find(
        (l) => l.type === "EDP"
      );
      n.push({
        idProduit: s.idProduct,
        modeDeFinancement: u.type
      });
    }
    return n;
  }
  _getPaymentMode(e, t, i) {
    var s;
    if ((t == null ? void 0 : t.type) === d.COFIDIS)
      return i && i === 2 ? "CREDIT_X3" : "CREDIT_MENSUEL";
    if ((t == null ? void 0 : t.type) !== d.CASH && (t == null ? void 0 : t.type) !== d.MULTI_PRODUCT)
      return (s = t.paymentModes[0]) == null ? void 0 : s.value;
    if (e != null && e.id)
      return e.value;
    throw new Error("La sélection du mode de paiement est obligatoire");
  }
  _getVirtualFundingModesPayload(e, t) {
    var i;
    return {
      paniers: [
        {
          parcours: e.quotes.map((s) => this._getVirtualQuoteApi(e, s, t))
        }
      ],
      utilisateur: {
        type: (i = this.user) != null && i.isCdc ? Oe.CDC : Oe.CLIENT
      },
      totalImmediat: this._getTotalImmediat(e)
    };
  }
  _getTotalImmediat(e) {
    let t = 0;
    return e.quotes.forEach((i) => {
      i.products.forEach((s) => {
        s.priceType === P.TODAY && s.prices.base > 0 && (t += s.prices.final || 0);
      });
    }), t;
  }
  _getVirtualQuoteApi(e, t, i) {
    var s, n, c;
    return {
      client: {
        type: this._clientTypeTranslation(((s = t.context) == null ? void 0 : s.clientType) ?? "CLIENT"),
        categorie: e.getCustomerCategory(),
        anciennete: this._nbTermsTranslation(
          ((n = t.context) == null ? void 0 : n.nbTerms) || A.MONTH24
        ),
        idContrat: (c = t.context) == null ? void 0 : c.contractId,
        idPu: i
      },
      type: t.context.id,
      produits: t.products.map((u) => this._getVirtualProductApi(t, u))
    };
  }
  _getVirtualProductApi(e, t) {
    var n;
    const i = e.getProductByType(a._plan), s = {
      parentGencode: t.data.parent_code,
      gencode: t.gencode,
      prix: t.priceType !== 0 ? 0 : t.prices.final,
      prixOrigine: t.priceType !== 0 ? 0 : t.prices.base,
      eligibleCredit: t.data.eligible_credit ?? !1,
      type: t.data.type_id
    };
    if (m.Is(t, a.phone)) {
      const c = t;
      if (s.edpTerminalNu = {
        amount: c.data.edp_phone.amount,
        duration: c.data.edp_phone.duration,
        price: c.data.edp_phone.price
      }, i && m.Is(i, a.plan_premium)) {
        const u = c.getEdpData(e);
        if (!u)
          return s;
        s.tarifications = {
          plans: {}
        }, s.tarifications.plans[i.gencode] = (n = c.data.prices.plans) == null ? void 0 : n[i.gencode], s.prixOrigine = u.price;
      }
    }
    return s;
  }
  _getCreditType(e, t = 63) {
    switch (e === d.COFIDIS && t++, t) {
      case 3:
        return e === d.COFIDIS ? d.COFIDIS_X3 : d.YOUNITED_X3;
      case 12:
        return e === d.COFIDIS ? d.COFIDIS_X12 : d.YOUNITED_X12;
      case 24:
        return e === d.COFIDIS ? d.COFIDIS_X24 : d.YOUNITED_X24;
      case 36:
        return d.YOUNITED_X36;
      default:
        return e === d.COFIDIS ? d.COFIDIS : d.YOUNITED;
    }
  }
  _nbTermsTranslation(e) {
    switch (e) {
      case A.MONTH12:
        return "12mois";
      case A.MONTH18:
        return "18mois";
      case A.MONTH24:
        return "24mois";
      default:
        return;
    }
  }
  _clientTypeTranslation(e) {
    return e === te.COLLABORATOR ? "collaborateur" : "client";
  }
  _getFundingMethodPosition(e) {
    switch (e.type) {
      case d.CASH:
        return 1;
      case d.MULTI_PRODUCT:
        return 3;
      case d.YOUNITED:
      case d.COFIDIS:
        return 2;
      default:
        return;
    }
  }
}
class Ut {
  constructor(e) {
    r(this, "catalogRepository");
    this.catalogRepository = e;
  }
  async getProductByGencode(e) {
    const t = await this.catalogRepository.getProductByGencode(e);
    return m.GetInstance(t);
  }
  async getProductsByAttributes(e, t) {
    const i = [];
    for (const s of e) {
      const n = await this._getProductByAttribute(s, t);
      i.push(n);
    }
    return i;
  }
  async getProductsByGencodes(e) {
    if (e.length > 0) {
      const t = await this.catalogRepository.getProductsByGencodes(e);
      return Object.values(t).map((i) => m.GetInstance(i));
    }
    throw new Error("Aucun gencode en paramètre");
  }
  async getLinkedProductAttributes(e, t) {
    try {
      const i = await this.catalogRepository.getProductByAttribute(e);
      return i[t] ? i[t].map((s) => ({
        gencode: s.gencode,
        position: s.position,
        hasDescription: s.hasDescription,
        firstPage: s.first_page,
        essential: s.essential
      })) : [];
    } catch {
      return [];
    }
  }
  async _getProductByAttribute(e, t) {
    const i = await this.catalogRepository.getProductByAttribute(e, t);
    return m.GetInstance(i);
  }
}
const ee = class ee {
  static IsCompatibleWithPromotions(e) {
    switch (!0) {
      case m.Is(e, a.option):
      case m.Is(e, a.insurance):
        return !1;
      default:
        return !0;
    }
  }
  static GetCartGenericParams(e, t = []) {
    var u, l;
    const i = e.getQuote();
    i.products.forEach((h) => {
      ee.IsApiProduct(h) && t.push(h.gencode);
    });
    const s = {
      typeParcours: e.getQuote().context.id,
      typeClient: e.getCustomerCategory(),
      edp: !!i.getProductsByType(a.edp).length,
      gencodes: t,
      noPersonne: e.userId
    };
    i.isRenewal() && (s.contractId = (l = (u = i.context) == null ? void 0 : u.contractId) == null ? void 0 : l.toString());
    const n = e.promotions.coupon;
    n && (s.coupon = n.code);
    const c = i.address.shipping;
    return c != null && c.codePostal && (s.adresse = { codePostal: c.codePostal }), s;
  }
  static IsApiProduct(e) {
    return e instanceof M && (e = e.gencode), !ee.InternalProductGencode.some((t) => e === t);
  }
};
r(ee, "InternalProductGencode", ["delivery", "edp", ...Object.values(Me)]);
let z = ee;
class Nt {
  constructor(e) {
    r(this, "config");
    r(this, "faiRepository");
    r(this, "galliumService");
    r(this, "checkoutStorage");
    this.config = e, this.checkoutStorage = new xe(e), this.faiRepository = new bt(this.checkoutStorage), this.galliumService = new Bt(this.checkoutStorage);
  }
  async deletePromotion(e, t) {
    return await It(this.config, e.cartId, t);
  }
  async getCouponPromotionForCart(e, t) {
    return (await this.getPromotionsForCart(e, [t])).coupon;
  }
  async getPromotionsForCart(e, t) {
    var s, n;
    if (!e.getQuote() || !e.getAllProducts().length)
      return new g([], [], []);
    ((s = e.promotions.coupon) != null && s.code && !t || (n = e.promotions.coupon) != null && n.code && t && e.promotions.coupon.code === t[0]) && (t = [e.promotions.coupon.code]);
    const i = await this.getPromotions(e, this._getCartGencodes(e), t);
    return e.promotions.coupon && i.coupon !== e.promotions.coupon && e.promotions.setCoupon(i.coupon), i;
  }
  async getPromotions(e, t, i, s) {
    try {
      const n = await this.getEligibilityPromoFromApi(e, t, i, s);
      return new g(
        n.automatic.concat(n.incitation.filter((c) => this._mustBeAutomatic(c, e))),
        n.manual,
        n.incitation,
        n.coupon
      );
    } catch (n) {
      return console.error(n), new g([], [], []);
    }
  }
  async getEligibilityPromoFromApi(e, t, i = [], s) {
    const n = this.getEligibilityPromoPayload(e, t, s);
    i.length > 0 && (n.panier.coupons = i);
    const u = (await Ct(this.config, n)).map((l) => this._getPromotions(l));
    return this._getMergedPromotion(u);
  }
  getEligibilityPromoPayload(e, t = {}, i, s, n) {
    const c = {
      typeClient: e.isPro ? ie.PRO : ie.GP,
      panier: {
        promotionsManuelles: [],
        parcours: this._getQuote(e)
      },
      produits: this._getPromoProducts(t, i),
      idPU: s,
      idContract: n
    };
    return e.getQuote().getProductByType(a.edp) && (c.panier.modeDeFinancement = d.MULTI_PRODUCT), c;
  }
  _getPromotions(e) {
    return e.parcours.map(
      (i) => {
        var s;
        return (s = i.produits) == null ? void 0 : s.reduce(
          (n, c) => {
            const u = new g(
              this._mergePromotions(
                n.automatic,
                c.promotions.automatiques.map(
                  (l) => this._getPromotionsModel(l, [c.gencode])
                )
              ),
              this._mergePromotions(
                n.manual,
                c.promotions.manuelles.map(
                  (l) => this._getPromotionsModel(l, [c.gencode])
                )
              ),
              this._mergePromotions(
                n.incitation,
                c.promotions.incitations.map(
                  (l) => this._getPromotionsModel(l, [c.gencode])
                )
              )
            );
            if (!e.avecLeProduit) {
              const l = c.promotions.coupons || [], h = c.promotions.couponsUniques || [], p = l.concat(h);
              p.length > 0 ? u.coupon = this._mergeCouponPromotion(
                n.coupon,
                this._getPromotionsModel(p[0], [c.gencode])
              ) : u.coupon = n.coupon;
            }
            return u;
          },
          new g([], [], [])
        );
      }
    ).reduce(
      (i, s) => new g(
        this._mergePromotions(i.automatic, s.automatic),
        this._mergePromotions(i.manual, s.manual),
        this._mergePromotions(i.incitation, s.incitation),
        this._mergeCouponPromotion(i.coupon, s.coupon)
      ),
      new g([], [], [])
    );
  }
  _mergeCouponPromotion(e, t) {
    var i;
    return !(e != null && e.code) && t !== void 0 ? t : ((i = t == null ? void 0 : t.relevantProducts) == null || i.forEach((s) => {
      e && !e.relevantProducts.includes(s) && e.relevantProducts.push(s);
    }), e);
  }
  _getPromotionsModel(e, t) {
    var i, s, n;
    return new V({
      id: e.id,
      addProduct: e.produitAAjouter,
      name: e.nom,
      label: e.libelle,
      type: e.type,
      description: e.description,
      amount: +e.valeurRemise,
      reductionType: e.typeRemise === "POURCENTAGE" ? ce.POURCENT : ce.FIX,
      reductionAmount: e.valeurRemiseReelle,
      duration: e.duree,
      dates: e.dates,
      code: e.type === Ee.COUPON || e.type === Ee.CPU ? e.coupon : void 0,
      message: { ...e.message, portability_other: (i = e.proprietesSupplementaires) == null ? void 0 : i.blocPorta },
      relevantProducts: t,
      typesMarketing: this._getTypesMarketingArray((s = e.proprietesSupplementaires) == null ? void 0 : s.typesMarketing),
      fanion: (n = e.proprietesSupplementaires) == null ? void 0 : n.fanion,
      accessTypes: e.typesAcces ?? []
    });
  }
  _getQuote(e) {
    return e.quotes.map((t, i) => ({
      type: t.context.id,
      idVirtuel: i,
      promotionsManuelles: [],
      produits: this._getProduct(t)
    }));
  }
  _getPromoProducts(e, t) {
    return Object.keys(e).map(
      (i) => {
        var s, n;
        return {
          ajouterDansLeParcours: e[i],
          gencode: i,
          codePostalFaiInstallation: ((n = (s = this.faiRepository.getEligibility()) == null ? void 0 : s.resultat) == null ? void 0 : n.codePostal) ?? null,
          rio: t
        };
      }
    );
  }
  _getProduct(e) {
    return e.products.filter((t) => z.IsApiProduct(t)).map(
      (t, i) => {
        var s, n;
        return {
          promotionsManuelles: t.promotions.manual.map((c) => c.id),
          gencode: t.gencode,
          idVirtuel: i,
          rio: this._setRioForProduct(e),
          codePostalFaiInstallation: (n = (s = this.faiRepository.getEligibility()) == null ? void 0 : s.resultat) == null ? void 0 : n.codePostal,
          // Temporary method - When get fundingMode ready use it
          modeDeFinancement: m.Is(t, a.phone) && e.getProductByType(a.edp) ? d.EDP : void 0
        };
      }
    );
  }
  _setRioForProduct(e) {
    var t, i, s, n;
    if ((i = (t = e.forms) == null ? void 0 : t.portability) != null && i.active)
      return (n = (s = e.forms) == null ? void 0 : s.portability) == null ? void 0 : n.codeRio;
  }
  _mergePromotions(e, t) {
    for (const i of t) {
      const s = e.find((n) => n.id === i.id);
      s || e.push(i), s && (s.relevantProducts = [.../* @__PURE__ */ new Set([...s.relevantProducts, ...i.relevantProducts])]);
    }
    return e;
  }
  /**
   * Merge promotions model
   * @param promos promotions model array
   * @returns PromotionsModel
   */
  _getMergedPromotion(e) {
    return e == null ? void 0 : e.reduce(
      (t, i) => new g(
        this._mergePromotions(t.automatic, i.automatic),
        this._mergePromotions(t.manual, i.manual),
        this._mergePromotions(t.incitation, i.incitation),
        this._mergeCouponPromotion(t.coupon, i.coupon)
      )
    );
  }
  _getTypesMarketingArray(e) {
    return e || [];
  }
  /**
   * Get current cart gencodes for eligibilty promo
   * @param cart Current cart
   * @returns List of gencodes
   */
  _getCartGencodes(e) {
    const i = e.getQuote().isRenewal();
    i && this.galliumService.renewalPriceUpdate(e);
    const s = {};
    return e.quotes.forEach((n, c) => {
      this._filterCartProducts(n.products, i).forEach((l) => l.crossSells.forEach((h) => s[h] = c));
    }), s;
  }
  _filterCartProducts(e, t) {
    return e.filter(
      (i) => z.IsCompatibleWithPromotions(i) && z.IsApiProduct(i) && // Ne pas inclure les forfaits mobiles => SIM en crossell
      !m.Is(i, a.plan_sowo) && !m.Is(i, a.plan_premium) && (!t || !m.Is(i, a._plan))
    );
  }
  _mustBeAutomatic(e, t) {
    return t.quotes.some((i) => {
      var n, c, u;
      const s = i.getProductByType(a._plan);
      return s && e.relevantProducts.includes(s.gencode) && ((n = s.portability) == null ? void 0 : n.active) && !((u = (c = i.forms) == null ? void 0 : c.portability) != null && u.codeRio) && e.accessTypes.includes(Ke.PORTABILITE);
    });
  }
}
const H = class H {
  constructor(e, t = [], i) {
    r(this, "fundingMethods");
    r(this, "storageService");
    r(this, "fundingRepository");
    r(this, "user");
    this.storageService = new xe(e), this.storageService.addLocalKey({
      [H.younited_key]: [He.ORDER]
    }), this.fundingRepository = new Mt(e, i), this.fundingMethods = t, this.user = i;
  }
  setUser(e) {
    this.user = e, this.fundingRepository.setUser(e);
  }
  setFundingMethods(e) {
    this.fundingMethods = e;
  }
  getLastFundingMethodsForCart() {
    return this.fundingMethods;
  }
  async getCurrentFundingMethod(e) {
    return this.fundingRepository.getCurrentFundingMethod(e);
  }
  async getFundingModes(e) {
    if (!e.cartId)
      throw new Error("Cart ID is required");
    const t = await this.fundingRepository.getFundingCart(e.cartId);
    return this.fundingMethods = t.fundingMethods, t;
  }
  async getVirtualFundingModes(e) {
    var t;
    return this.fundingRepository.getVirtualCartFundingModes(e, (t = this.user) == null ? void 0 : t.id);
  }
  getYounitedSelectedProposal(e) {
    if (!e || e.type !== d.YOUNITED) return;
    const t = e.commercialProposal;
    let i, s = t[0];
    const n = t.find((u) => u.nbLoan === 24);
    return this.getCreditChoice() && (i = t.find((u) => u.nbLoan === this.getCreditChoice())), i ? s = i : n && (s = n), s;
  }
  getCofidisSelectedProposal(e) {
    if (!e || e.type !== d.COFIDIS) return;
    const t = e.commercialProposal;
    let i, s = t[0];
    const n = t.find((u) => u.nbLoan === 2);
    return this.getCreditChoice() && (i = t.find((u) => u.nbLoan === this.getCreditChoice())), i ? s = i : n && (s = n), s;
  }
  getCreditChoice() {
    return this.storageService.get(H.younited_key);
  }
  saveCreditChoice(e) {
    this.storageService.set(H.younited_key, e);
  }
};
r(H, "younited_key", "funding_selected");
let ve = H;
class Bt {
  constructor(e) {
    r(this, "_storageKey", "galliumPrices");
    r(this, "checkoutStorage");
    this.checkoutStorage = e;
  }
  getGalliumPrices(e) {
    const t = this.checkoutStorage.get(this._storageKey, !1);
    return t && (t == null ? void 0 : t[e]);
  }
  renewalPriceUpdate(e) {
    var i;
    const t = e.getQuote().getProductByType(a._plan);
    if (t) {
      const s = this.checkoutStorage.get(this._storageKey, !1), n = s && s[(i = t == null ? void 0 : t.data) == null ? void 0 : i.gencode];
      n && (t.data.price = t.prices.base = t.prices.final = Object.prototype.hasOwnProperty.call(n, "promoPrice") ? n.promoPrice : n.price);
    }
  }
}
class kt {
  /**
   * Check referrer validity into domain
   * @param referrers referrers list
   * @returns boolean
   */
  isReferrerValid(e) {
    const t = this._getReferrerDomain();
    return !(e && !t || e && t && !e.some((i) => t.includes(i)));
  }
  /**
   * Extract domain from referrer
   * @returns string
   */
  _getReferrerDomain() {
    const e = document.referrer ? new URL(document.referrer) : void 0;
    return e == null ? void 0 : e.hostname;
  }
}
class Qt extends Error {
  constructor(t) {
    super();
    r(this, "errorThrown", !0);
    this.message = t;
  }
}
class Yt extends Qt {
  constructor() {
    super(...arguments);
    r(this, "errorThrown", !1);
    r(this, "name", "partner_error");
  }
}
class $t extends kt {
  constructor(t) {
    super();
    r(this, "config");
    this.config = t;
  }
  /**
   * Check if partner offer is valid
   * @param urlKeys url key attribut
   * @returns null if valid or partnerOffers name for error modal
   */
  isPartnerOfferValid(t) {
    var c, u;
    const i = ((c = this.config.partner) == null ? void 0 : c.offers) ?? {}, s = t.find((l) => i[l]);
    if (!s)
      throw new Error("Partner URL not found");
    const n = (u = i[s]) == null ? void 0 : u.referrer;
    return this.isReferrerValid(n) ? void 0 : i[s];
  }
  checkProductReferrer(t) {
    this._checkYamaReferrer(t);
  }
  _checkYamaReferrer(t) {
    var s;
    const i = ((s = this.config.yama) == null ? void 0 : s.referrers) || [];
    if (t.data.banking_offer === !0 && !this.isReferrerValid(i))
      throw new Yt("OMB exclusive offer");
  }
}
class Xt {
  static GetPromotionsForProduct(e, t) {
    const i = t.coupon;
    return new g(
      t.automatic.filter((s) => this.isApplicable(e, s)),
      t.manual.filter((s) => this.isApplicable(e, s)),
      t.incitation.filter((s) => this.isApplicable(e, s)),
      i && this.isApplicable(e, i) ? i : void 0
    );
  }
  static isApplicable(e, t) {
    return t.relevantProducts.includes(e.gencode);
  }
}
class Gt {
  /**
   * Add product to current quote by gencode
   */
  addProduct(e, t) {
    return !t || !t.canAdd(e) ? this : (t.getIncompatible(e).forEach((i) => this.removeProduct(e, i, t)), t.beforeAdd(this, e), e.products.push(t), t.afterAdd(this, e), e.products.forEach((i) => i.onItemAddedInQuote(e, t)), this);
  }
  removeProduct(e, t, i = null) {
    return t ? (e.products = e.products.filter((s) => s !== t), t.afterRemove(this, e), t.getRelated(e).filter((s) => !i || !i.keepProduct(e, s)).forEach((s) => this.removeProduct(e, s, i)), t.getAutoAdded(e).filter((s) => !i || !i.keepProduct(e, s)).forEach((s) => this.removeProduct(e, s, i)), e.products.forEach((s) => s.onItemRemovedFromQuote(e, t)), this) : this;
  }
  removeProductsByType(e, t, i = !1) {
    return e.getProductsByType(t, i).forEach((s) => this.removeProduct(e, s)), this;
  }
  removeProductByGencode(e, t) {
    return this.removeProduct(e, e.getProductByGencode(t)), this;
  }
  removeProductsByGencode(e, t) {
    return t.forEach((i) => this.removeProductByGencode(e, i)), this;
  }
  refresh(e) {
    e.products.forEach((t) => t.refresh(this, e)), e.totals = e.calculateTotals();
  }
  calculatePrices(e, t) {
    e.products.forEach(
      (i) => i.calculatePrices(e, Xt.GetPromotionsForProduct(i, t))
    );
  }
}
class Ht {
  constructor() {
    r(this, "CONTEXT_TYPE", [x, j, K]);
  }
  initContextFromStorage(e) {
    const t = this.CONTEXT_TYPE.find((i) => new i().id === e.id);
    if (!t)
      throw new Error("Context not found");
    return new t(e);
  }
  createContext(e, t) {
    switch (new e().id) {
      case w.RENEW:
        throw new Error("Not implemented");
      case w.ACQUISITIONFIX:
        return new K(t);
      default:
        return new x(t);
    }
  }
}
const L = class L {
  constructor(e, t) {
    r(this, "user");
    r(this, "checkoutStorage");
    // Si le client met au panier un produit (terminal / galet) éligible à l'étalement de paiement
    // alors que global.edp présente un message
    // Alors ne pas proposer l'EDP dans les choix de mode de paiement
    r(this, "_storageScoringKey", "scoring");
    this.checkoutStorage = e, this.user = t;
  }
  setUser(e) {
    this.user = e;
  }
  deleteScoring() {
    this.checkoutStorage.remove(this._storageScoringKey);
  }
  getScoringFromStorage(e, t = !1) {
    const i = this.checkoutStorage.get(this._storageScoringKey);
    return this._get(i, `${e}${t ? "" : ".message"}`);
  }
  saveScoring(e) {
    this.checkoutStorage.set(this._storageScoringKey, e, !0, nt(/* @__PURE__ */ new Date(), 1).getTime());
  }
  checkScoring(e) {
    if (this.user) {
      const t = Object.keys(L.INCOMPATIBLE_RULES).find(
        (s) => L.INCOMPATIBLE_RULES[s].find((n) => m.Is(e, n, !0))
      );
      if (!t)
        return;
      const i = this.getScoringFromStorage(t);
      if (i)
        throw new Error(i);
    } else
      this.deleteScoring();
  }
  isEDPIncompatible() {
    return !!this.getScoringFromStorage(L.EDP_GLOBAL, !0);
  }
  _get(e, t) {
    const i = t.split(".");
    let s = e;
    return i.forEach((n) => {
      s = s && s[n];
    }), s;
  }
};
r(L, "INCOMPATIBLE_RULES", {
  "global.ligneMarcheFnb.voixSansEngagement": [a.plan_sowo],
  "global.ligneMarcheFnb.voixAvecEngagement": [a.plan_simo, a.plan_premium],
  "global.ligneMarcheFnb.forfaitData": [
    a.faim,
    a.faim_unlimited,
    a.faim_premium
  ],
  "global.ligneMarcheFai.fai": [a.fai]
}), r(L, "EDP_GLOBAL", "global.edp");
let Le = L;
class Kt {
  constructor(e, t) {
    r(this, "fundingService");
    r(this, "edpService");
    this.fundingService = e, this.edpService = new Fe(t);
  }
  async setFundingDefaultValue(e, t) {
    if (e.isCartEmpty())
      throw new Error("Cart is empty");
    t === d.EDP && await this.edpService.addEdpProduct(e);
    const i = await this._getFundingModes(e);
    if (!i)
      return;
    let s;
    if (t === d.EDP) {
      const n = i.fundingMethods.find(
        (c) => c.type === d.MULTI_PRODUCT
      );
      n ? s = n : await this.edpService.removeEdpProduct(e);
    } else
      await this.edpService.removeEdpProduct(e), t !== d.CASH && (s = await this._selectYounited(i.fundingMethods, t));
    return s;
  }
  async _selectYounited(e, t) {
    const i = e.find((s) => s.type === d.YOUNITED);
    if (i) {
      const s = t.match(/^younited_x(\d+)$/i), n = s ? Number(s[1]) : 24;
      return this.fundingService.saveCreditChoice(n), i;
    }
  }
  async _getFundingModes(e) {
    var i;
    return e.cartId && ((i = e.quotes) == null ? void 0 : i.every((s) => s.id)) ? this.fundingService.getFundingModes(e) : this.fundingService.getVirtualFundingModes(e);
  }
}
async function Vt(o, e, t, i) {
  if (!(await fetch(`${o.resourceUrl}/ventes/paniers/${e}/parcours/${t}`, {
    headers: {
      ...O(o),
      ...i
    },
    method: "DELETE"
  })).ok)
    throw new Error("Error while deleting quote");
  return !0;
}
const qt = "yama_cart";
class jt {
  constructor(e, t, i, s) {
    r(this, "cart");
    r(this, "config");
    r(this, "quoteService");
    r(this, "cartRepository");
    r(this, "productRepository");
    r(this, "catalogRepository");
    r(this, "promotionRepository");
    r(this, "fundingService");
    r(this, "checkoutStorage");
    r(this, "deliveryService");
    r(this, "contractId");
    r(this, "user");
    r(this, "currentStepKey", "current_step");
    r(this, "useVirtualFundingStepKeysList", ["cart", "summary"]);
    r(this, "partnersService");
    r(this, "scoringService");
    r(this, "addFundingService");
    this.config = tt(e), this.quoteService = new Gt(), this.cartRepository = new _t(), this.catalogRepository = new At(this.config), this.productRepository = new Ut(this.catalogRepository), this.checkoutStorage = new xe(this.config), this.promotionRepository = new Nt(this.config), this.partnersService = new $t(this.config), this.fundingService = new ve(this.config, void 0, i), this.deliveryService = new yt(), this.scoringService = new Le(this.checkoutStorage, i), this.addFundingService = new Kt(this.fundingService, this), t = t ?? new Ne(), this.cart = t, this.initCart(), this.user = i, this.contractId = s;
  }
  /**
   * Return all products by type from cart (all quotes)
   */
  getAllProductsByType(e) {
    let t = [];
    return this.cart.quotes.forEach((i) => {
      t = t.concat(i.getProductsByType(e));
    }), t;
  }
  getQuotes() {
    return this.cart.quotes;
  }
  getCoupon() {
    return this.cart.promotions.coupon;
  }
  async setCoupon(e) {
    const t = await this.promotionRepository.getCouponPromotionForCart(this.cart, e);
    t && (this.cart.promotions.setCoupon(t), await this.refresh());
  }
  getContractId() {
    return this.contractId;
  }
  setContractId(e) {
    this.contractId = e;
  }
  setUser(e) {
    this.user = e, this.fundingService.setUser(e), this.scoringService.setUser(e);
  }
  async removeCoupon(e = !0) {
    this.cart.promotions.removeCoupon(), e && await this.refresh();
  }
  async addProductsToCart(e, t = !1, i = !1) {
    const s = this.cart.isMixed(), n = await this.productRepository.getProductsByGencodes(e), c = n.every((p) => m.Is(p, a.accessory));
    if (i)
      return this.handleRenewalContext(n, c);
    const u = this.determineProductCompatibility(n, t), l = [this.cart.getQuote(0), this.cart.getQuote(1)], h = t ? new K() : new x();
    return s ? this._handleAddToMixedCart(
      c,
      n,
      l,
      u,
      h
    ) : this._handleAddToNonMixedCart(c, n, l, u, h);
  }
  async addProductsByAttributes(e, t) {
    const i = await this.productRepository.getProductsByAttributes(e, t);
    return this.addProducts(i);
  }
  /**
   * Remove product from specific quote by gencode
   * @return Observable
   */
  async removeProduct(e, t = this.cart.currentQuoteIndex, i = !0) {
    const s = this.cart.quotes[t];
    this.quoteService.removeProduct(s, e);
    let n = e;
    if (e.autoAdd.length)
      for (const c of e.autoAdd) {
        const u = this.cart.getQuote(t).getProductByGencode(c);
        u && (n = await this.removeProduct(u, t, !1));
      }
    return await this.deliveryService.removeDelivery(this, e, t), this._cleanForms(e, t), i && (await this.updateFunding(), await this.refresh()), this.updateHeaderProductCounter(), n;
  }
  async removeProductsByGencodes(e, t = this.cart.currentQuoteIndex) {
    const i = this.cart.quotes[t], s = [];
    i.getProductsByGencodes(e).forEach((c) => {
      s.push(this.removeProduct(c, t, !1));
    });
    const n = (await Promise.all(s)).filter(this.isProduct);
    return await this._checkCoupon(), await this.updateFunding(), await this.refresh(t), n;
  }
  /**
   * Remove product from specific quote by type
   * @return Observable
   */
  async removeProductsByType(e, t = this.cart.currentQuoteIndex) {
    const i = this.cart.quotes[t], s = [];
    i.getProductsByType(e).forEach((u) => {
      s.push(this.removeProduct(u, t, !1));
    });
    const c = (await Promise.all(s)).filter(this.isProduct);
    return await this._checkCoupon(), await this.updateFunding(), await this.refresh(t), c;
  }
  isEmpty() {
    return this.cart.isCartEmpty();
  }
  isProduct(e) {
    return e !== null;
  }
  clear() {
    this.cart.totals = void 0, this.cart.currentQuoteIndex = 0, this.cart.promotions = new g([], [], []), this.cart.quotes = [], this.cart.fundingMethod = void 0, this.addQuote(), this.save();
  }
  length() {
    return this.cart.length();
  }
  determineProductCompatibility(e, t) {
    const i = this.cart.getQuote(0).products.some((h) => m.Is(h, a.fai)), s = e.some(
      (h) => m.Is(h, a.plan_sowo) || m.Is(h, a.plan_simo)
    ), n = e.some((h) => h.categories.includes(
      "FAI-SIMO"
      /* FAI_SIMO */
    )), c = e.some((h) => m.Is(h, a.phone)), u = e.some((h) => m.Is(h, a.faim_unlimited));
    return t && !u || (i ? n : s) && !c;
  }
  initCart() {
    this.cartRepository.initCartFromStorage(this.cart) || this.addQuote(), typeof document < "u" && !document.location.href.includes("tunnel/redirect") && this._checkCartValidity(this.cart).then(async (e) => {
      e ? (this.refreshType(), await this.refresh(this.cart.currentQuoteIndex)) : (this.clear(), this.addQuote());
    });
  }
  async _checkCoupon() {
    const e = this.cart.promotions.coupon;
    if (e != null && e.code)
      try {
        const t = await this.promotionRepository.getCouponPromotionForCart(this.cart, e.code);
        t ? this.cart.promotions.setCoupon(t) : await this.removeCoupon();
      } catch {
        await this.promotionRepository.deletePromotion(this.cart), await this.removeCoupon();
      }
  }
  async _checkCartValidity(e) {
    const t = e.getAllProducts(), i = t.map((s) => s.gencode);
    try {
      return !(await this.productRepository.getProductsByGencodes(i)).some((n) => {
        const c = t.find((u) => u.gencode === n.gencode);
        return !this._isProductValid(n, c);
      });
    } catch {
      return !0;
    }
  }
  _isProductValid(e, t) {
    return e.data.type_id === t.data.type_id;
  }
  /**
   * Add product to current quote by gencode
   */
  async addProduct(e, t = this.cart.currentQuoteIndex, i = !0) {
    if (!e)
      throw new Error("Product is not defined");
    this.cart.quotes[t] || (this.addQuote(), t = this.cart.quotes.length - 1);
    const s = this.cart.quotes[t];
    return !s.isRenewal() && this.cart.type !== J.BANK && this.partnersService.checkProductReferrer(e), this._checkStock(e), this.scoringService.checkScoring(e), this.quoteService.addProduct(s, e), await this.deliveryService.removeDelivery(this, e, t), this._cleanForms(e, t), i && (this.cart.promotions = await this.promotionRepository.getPromotionsForCart(this.cart), await this._checkCoupon(), await this.refresh()), this.updateHeaderProductCounter(), [e];
  }
  _checkStock(e) {
    if (!e.isInStock())
      throw new Error(`${e.name} est hors stock`);
  }
  _cleanForms(e, t = this.cart.currentQuoteIndex) {
    const i = this.cart.getQuote(t);
    m.Is(e, a._plan) && (delete i.forms.portability, delete i.forms.funding, delete i.forms.paymentMethod, delete i.forms.appointment, delete i.forms.parentalControl, delete i.forms.mrz, delete i.forms.siren), m.Is(e, a.phone) && (delete i.forms.portability, delete i.forms.funding, delete i.forms.paymentMethod, delete i.forms.insurances, delete i.forms.simCard);
  }
  updateHeaderProductCounter() {
    const e = new CustomEvent("onCartChanges", {
      detail: {
        count: this.length(),
        context: this.cart.quotes.reduce((t, i) => (i.context.id && (t = [.../* @__PURE__ */ new Set([...t, i.context.id])]), t), [])
      }
    });
    typeof document < "u" && document.dispatchEvent(e);
  }
  addQuote(e = new x()) {
    const t = new _e({
      products: [],
      context: e,
      address: {
        shipping: null,
        billing: null
      },
      forms: {}
    });
    return this.cart.quotes.push(t), this.cart.quotes.length - 1;
  }
  async removeQuote(e = 0) {
    this.cart.quotes = this.cart.quotes.filter((t, i) => i !== e), await this.refresh();
  }
  calculatePrices() {
    this.cart.quotes.forEach((e) => this.quoteService.calculatePrices(e, this.cart.promotions));
  }
  async refresh(e) {
    e !== void 0 ? this.quoteService.refresh(this.cart.quotes[e]) : this.cart.quotes.forEach((i) => this.quoteService.refresh(i));
    const t = await this.promotionRepository.getPromotionsForCart(this.cart);
    t.manual = this.cart.promotions.manual, t.coupon = this.cart.promotions.coupon, this.cart.promotions = t, this.cart.quotes.forEach((i) => this.quoteService.refresh(i)), this.calculatePrices(), this.cart.calculateTotals();
    try {
      this.refreshCartIsPro(), this.save();
    } catch (i) {
      console.error(i);
    }
  }
  refreshCartIsPro() {
    var s;
    if (this.cart.isCartEmpty()) {
      this.setPro(!1);
      return;
    }
    const t = this.cart.getQuote().getPrincipalProduct(a._plan), i = (((s = this.user) == null ? void 0 : s.isPro) ?? !1) || (t == null ? void 0 : t.isPro) || this.cart.isComingFromProWall;
    this.setPro(i);
  }
  setPro(e = !0) {
    this.cart.isPro = e;
  }
  save() {
    this.cartRepository.saveCart(this.cart);
  }
  _getProductSortOrder(e) {
    const i = [a._plan, a.phone].findIndex((s) => m.Is(e, s));
    return i === -1 ? 1 / 0 : i;
  }
  async addProducts(e, t = 0) {
    e.sort(
      (s, n) => Math.sign(this._getProductSortOrder(s) - this._getProductSortOrder(n))
    );
    const i = e.map((s) => this.addProduct(s, t, !1));
    try {
      await Promise.all(i);
    } catch (s) {
      console.error(s);
    }
    try {
      this.cart.promotions = await this.promotionRepository.getPromotionsForCart(this.cart), await this.refresh(t), await this.updateFunding(t);
    } catch (s) {
      console.error(s);
    }
    return e;
  }
  async updateFunding(e = 0) {
    var i;
    const t = this.cart.fundingMethod;
    if ((t == null ? void 0 : t.type) === d.YOUNITED && this.cart.getQuote(e).products.length > 0) {
      let s;
      this.cart.cartId && ((i = this.cart.quotes[e]) != null && i.id) && !this.currentStepMustUseVirtualFunding() ? s = await this.fundingService.getFundingModes(this.cart) : s = await this.fundingService.getVirtualFundingModes(this.cart);
      const n = s == null ? void 0 : s.fundingMethods.find(
        (c) => c.type === t.type
      );
      this._setFundingMethod(n);
    }
  }
  async setFundingMethod(e) {
    const t = await this.addFundingService.setFundingDefaultValue(this.cart, e);
    this._setFundingMethod(t);
  }
  getFundingMethod() {
    return this.cart.fundingMethod;
  }
  _setFundingMethod(e) {
    return this.cart.fundingMethod = e, this.fundingService.setFundingMethods(e ? [e] : []), this.save(), !0;
  }
  currentStepMustUseVirtualFunding() {
    const e = this.checkoutStorage.get(this.currentStepKey);
    return !this.useVirtualFundingStepKeysList.includes(e);
  }
  refreshType() {
    const e = this.checkoutStorage.get(qt, !1);
    this.cart.type = e ? J.BANK : J.WEB;
  }
  async _handleAddToNonMixedCart(e, t, i, s, n) {
    var f, E, _;
    const [c, u] = i, l = n.id === c.context.id;
    if (l)
      return this.addProducts(t, 0);
    if (!l && this.cart.cartId && c.id && this.user) {
      const y = {};
      y.Authorization = `Bearer ${this.user.accessToken}`;
      try {
        await Vt(this.config, this.cart.cartId, c.id, y);
      } catch (U) {
        console.log(U);
      }
      delete c.id;
    }
    if (!((f = c.products) != null && f.some(
      (y) => m.Is(y, a.accessory) || m.Is(y, a.phone) || m.Is(y, a.faim_unlimited)
    )) && s && c.products.length > 0 && !e) {
      if (!u)
        return this.addQuote(n), await this.addProducts(t, 1);
      if (((E = u == null ? void 0 : u.products) == null ? void 0 : E.length) === 0)
        return await this.addProducts(t, 1);
    } else
      return e || (this.cart.quotes[0].context = n), u != null && u.products && ((_ = u == null ? void 0 : u.products) == null ? void 0 : _.length) === 0 ? (await this.removeQuote(1), await this.addProducts(t, 0)) : this.addProducts(t, 0);
    return this.cart.quotes[0].context = n, await this.addProducts(t, 0);
  }
  async _handleAddToMixedCart(e, t, i, s, n) {
    if (e)
      return await this.removeQuote(1), await this.removeQuote(0), await this.addProducts(t, 0);
    if (s) {
      const c = i.findIndex((u) => {
        var l;
        return ((l = u.context) == null ? void 0 : l.id) === n.id;
      });
      return await this.addProducts(t, c);
    }
    return await this.removeQuote(1), await this.removeQuote(0), await this.addProducts(t, 0), t;
  }
  async handleRenewalContext(e, t = !1) {
    var W;
    if (t)
      return this.addProducts(e, 0);
    if (!this.user)
      throw new Error("User is required for renewal");
    if (!this.contractId)
      throw new Error("Contract ID is required for renewal");
    const i = {
      authorization: `Bearer ${this.user.accessToken}`
    }, [s, n, c, u] = await Promise.allSettled([
      Tt(this.config, this.contractId, i),
      wt(this.config, this.contractId, i),
      Ot(this.config, this.contractId, i),
      Et(this.config, this.contractId, i)
    ]), l = s.status === "fulfilled" ? s.value : void 0, h = n.status === "fulfilled" ? n.value : void 0, p = c.status === "fulfilled" ? c.value : void 0, f = u.status === "fulfilled" ? u.value : void 0, E = (W = f == null ? void 0 : f.items) != null && W.length ? f.items[0].numeroTel.replace("+33", "0") : "", _ = Dt(h), y = {
      phone: E,
      contractId: this.contractId,
      clientType: l != null && l.contratCollaborateur ? te.COLLABORATOR : te.CLIENT,
      currentPlan: l == null ? void 0 : l.abonnement.idOffre,
      options: p == null ? void 0 : p.items,
      nbTerms: l != null && l.isSowo ? null : _
    }, U = this.cart.quotes[0];
    U.context = new j(y);
    const ne = this.addProducts(e, 0);
    return this.refreshType(), this.save(), ne;
  }
}
typeof window < "u" && (window.Magicart = jt, window.FundingMethod = B);
export {
  F as ENV_LIST,
  B as FundingMethod,
  a as ProductTypes,
  jt as default
};
//# sourceMappingURL=magicart.js.map
